
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;
        let url = '';
        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }
        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }
        return url + relativeUrl;
      }
import __SNOWPACK_ENV__ from '../__snowpack__/env.js';
({ url: getAbsoluteUrl('_dist_/app.js'), env: __SNOWPACK_ENV__ }).env = __SNOWPACK_ENV__;

import _styled171 from "../web_modules/styled-components.js";
import _styled170 from "../web_modules/styled-components.js";
import _styled169 from "../web_modules/styled-components.js";
import _styled168 from "../web_modules/styled-components.js";
import _styled167 from "../web_modules/styled-components.js";
import _styled166 from "../web_modules/styled-components.js";
import _styled165 from "../web_modules/styled-components.js";
import _styled164 from "../web_modules/styled-components.js";
import _styled163 from "../web_modules/styled-components.js";
import _styled162 from "../web_modules/styled-components.js";
import _styled161 from "../web_modules/styled-components.js";
import _styled160 from "../web_modules/styled-components.js";
import _styled159 from "../web_modules/styled-components.js";
import _styled158 from "../web_modules/styled-components.js";
import _styled157 from "../web_modules/styled-components.js";
import _styled156 from "../web_modules/styled-components.js";
import _styled155 from "../web_modules/styled-components.js";
import _styled154 from "../web_modules/styled-components.js";
import _styled153 from "../web_modules/styled-components.js";
import _styled152 from "../web_modules/styled-components.js";
import _styled151 from "../web_modules/styled-components.js";
import _styled150 from "../web_modules/styled-components.js";
import _styled149 from "../web_modules/styled-components.js";
import _styled148 from "../web_modules/styled-components.js";
import _styled147 from "../web_modules/styled-components.js";
import _styled146 from "../web_modules/styled-components.js";
import _styled145 from "../web_modules/styled-components.js";
import _styled144 from "../web_modules/styled-components.js";
import _styled143 from "../web_modules/styled-components.js";
import _styled142 from "../web_modules/styled-components.js";
import _styled141 from "../web_modules/styled-components.js";
import _styled140 from "../web_modules/styled-components.js";
import _styled139 from "../web_modules/styled-components.js";
import _styled138 from "../web_modules/styled-components.js";
import _styled137 from "../web_modules/styled-components.js";
import _styled136 from "../web_modules/styled-components.js";
import _styled135 from "../web_modules/styled-components.js";
import _styled134 from "../web_modules/styled-components.js";
import _styled133 from "../web_modules/styled-components.js";
import _styled132 from "../web_modules/styled-components.js";
import _styled131 from "../web_modules/styled-components.js";
import _styled130 from "../web_modules/styled-components.js";
import _styled129 from "../web_modules/styled-components.js";
import _styled128 from "../web_modules/styled-components.js";
import _styled127 from "../web_modules/styled-components.js";
import _styled126 from "../web_modules/styled-components.js";
import _styled125 from "../web_modules/styled-components.js";
import _styled124 from "../web_modules/styled-components.js";
import _styled123 from "../web_modules/styled-components.js";
import _styled122 from "../web_modules/styled-components.js";
import _styled121 from "../web_modules/styled-components.js";
import _styled120 from "../web_modules/styled-components.js";
import _styled119 from "../web_modules/styled-components.js";
import _styled118 from "../web_modules/styled-components.js";
import _styled117 from "../web_modules/styled-components.js";
import _styled116 from "../web_modules/styled-components.js";
import _styled115 from "../web_modules/styled-components.js";
import _styled114 from "../web_modules/styled-components.js";
import _styled113 from "../web_modules/styled-components.js";
import _styled112 from "../web_modules/styled-components.js";
import _styled111 from "../web_modules/styled-components.js";
import _styled110 from "../web_modules/styled-components.js";
import _styled109 from "../web_modules/styled-components.js";
import _styled108 from "../web_modules/styled-components.js";
import _styled107 from "../web_modules/styled-components.js";
import _styled106 from "../web_modules/styled-components.js";
import _styled105 from "../web_modules/styled-components.js";
import _styled104 from "../web_modules/styled-components.js";
import _styled103 from "../web_modules/styled-components.js";
import _styled102 from "../web_modules/styled-components.js";
import _styled101 from "../web_modules/styled-components.js";
import _styled100 from "../web_modules/styled-components.js";
import _styled99 from "../web_modules/styled-components.js";
import _styled98 from "../web_modules/styled-components.js";
import _styled97 from "../web_modules/styled-components.js";
import _styled96 from "../web_modules/styled-components.js";
import _styled95 from "../web_modules/styled-components.js";
import _styled94 from "../web_modules/styled-components.js";
import _styled93 from "../web_modules/styled-components.js";
import _styled92 from "../web_modules/styled-components.js";
import _styled91 from "../web_modules/styled-components.js";
import _styled90 from "../web_modules/styled-components.js";
import _styled89 from "../web_modules/styled-components.js";
import _styled88 from "../web_modules/styled-components.js";
import _styled87 from "../web_modules/styled-components.js";
import _styled86 from "../web_modules/styled-components.js";
import _styled85 from "../web_modules/styled-components.js";
import _styled84 from "../web_modules/styled-components.js";
import _styled83 from "../web_modules/styled-components.js";
import _styled82 from "../web_modules/styled-components.js";
import _styled81 from "../web_modules/styled-components.js";
import _styled80 from "../web_modules/styled-components.js";
import _styled79 from "../web_modules/styled-components.js";
import _styled78 from "../web_modules/styled-components.js";
import _styled77 from "../web_modules/styled-components.js";
import _styled76 from "../web_modules/styled-components.js";
import _styled75 from "../web_modules/styled-components.js";
import _styled74 from "../web_modules/styled-components.js";
import _styled73 from "../web_modules/styled-components.js";
import _styled72 from "../web_modules/styled-components.js";
import _styled71 from "../web_modules/styled-components.js";
import _styled70 from "../web_modules/styled-components.js";
import _styled69 from "../web_modules/styled-components.js";
import _styled68 from "../web_modules/styled-components.js";
import _styled67 from "../web_modules/styled-components.js";
import _styled66 from "../web_modules/styled-components.js";
import _styled65 from "../web_modules/styled-components.js";
import _styled64 from "../web_modules/styled-components.js";
import _styled63 from "../web_modules/styled-components.js";
import _styled62 from "../web_modules/styled-components.js";
import _styled61 from "../web_modules/styled-components.js";
import _styled60 from "../web_modules/styled-components.js";
import _styled59 from "../web_modules/styled-components.js";
import _styled58 from "../web_modules/styled-components.js";
import _styled57 from "../web_modules/styled-components.js";
import _styled56 from "../web_modules/styled-components.js";
import _styled55 from "../web_modules/styled-components.js";
import _styled54 from "../web_modules/styled-components.js";
import _styled53 from "../web_modules/styled-components.js";
import _styled52 from "../web_modules/styled-components.js";
import _styled51 from "../web_modules/styled-components.js";
import _styled50 from "../web_modules/styled-components.js";
import _styled49 from "../web_modules/styled-components.js";
import _styled48 from "../web_modules/styled-components.js";
import _styled47 from "../web_modules/styled-components.js";
import _styled46 from "../web_modules/styled-components.js";
import _styled45 from "../web_modules/styled-components.js";
import _styled44 from "../web_modules/styled-components.js";
import _styled43 from "../web_modules/styled-components.js";
import _styled42 from "../web_modules/styled-components.js";
import _styled41 from "../web_modules/styled-components.js";
import _styled40 from "../web_modules/styled-components.js";
import _styled39 from "../web_modules/styled-components.js";
import _styled38 from "../web_modules/styled-components.js";
import _styled37 from "../web_modules/styled-components.js";
import _styled36 from "../web_modules/styled-components.js";
import _styled35 from "../web_modules/styled-components.js";
import _styled34 from "../web_modules/styled-components.js";
import _styled33 from "../web_modules/styled-components.js";
import _styled32 from "../web_modules/styled-components.js";
import _styled31 from "../web_modules/styled-components.js";
import _styled30 from "../web_modules/styled-components.js";
import _styled29 from "../web_modules/styled-components.js";
import _styled28 from "../web_modules/styled-components.js";
import _styled27 from "../web_modules/styled-components.js";
import _styled26 from "../web_modules/styled-components.js";
import _styled25 from "../web_modules/styled-components.js";
import _styled24 from "../web_modules/styled-components.js";
import _styled23 from "../web_modules/styled-components.js";
import _styled22 from "../web_modules/styled-components.js";
import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../web_modules/react.js";
import { BrowserRouter as Router, Switch, Route, useParams, useRouteMatch, useHistory, useLocation, Redirect } from "../web_modules/react-router-dom.js";
import Turnstile, { useTurnstile } from "../web_modules/react-turnstile.js";
import { createGlobalStyle } from "../web_modules/styled-components.js";
import ContentLoader from "../web_modules/react-content-loader.js";
import WebFont from "../web_modules/webfontloader.js";
import Cookie from "../web_modules/js-cookie.js";
import * as Sentry from "../web_modules/@sentry/browser.js";
import { LinkedInTag } from "../web_modules/react-linkedin-insight.js";
import TagManager from "../web_modules/react-gtm-module.js";
import ReactGA from "../web_modules/react-ga4.js"; // @ts-expect-error: TODO: Type this

import serialize from "../web_modules/for-cerial.js";
import { DialogOverlay, DialogContent } from "../web_modules/@reach/dialog.js";
import "../web_modules/@reach/dialog/styles.css";
import VisuallyHidden from "../web_modules/@reach/visually-hidden.js";
import { Menu, MenuButton, MenuLink, MenuPopover, MenuItems } from "../web_modules/@reach/menu-button.js";
import { LanguageSelector, Spinner, LoadingButton } from "../web_modules/@ticketbutler/toolbox.js";
import "../web_modules/@ticketbutler/toolbox/dist/style.css";
import "../web_modules/@reach/menu-button/styles.css";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import { t } from "../web_modules/i18next.js";
import { Trans, useTranslation, withTranslation } from "../web_modules/react-i18next.js";
import { loadStripe } from "../web_modules/@stripe/stripe-js.js";
import { PaymentElement, Elements, useStripe, useElements } from "../web_modules/@stripe/react-stripe-js.js";
import { SelfRegistration } from "./self_registration.js";
import { EventPage } from "./event_page.js";
import { EventList } from "./event_list.js";
import { useCheckoutNavigate, CheckoutContext, CHECKOUT_ROUTE, CHECKOUT_DIALOG_BORDER_RADIUS, CHECKOUT_PATHS } from "./checkout.js";
import { getSearchParams, isIframe, urlParams, useIframeTypes, useScrollToError, Checkbox, isCheckoutModal } from "./shared.js";
import { Language } from "./interfaces.js";
import ticketbutlerLogo from "./assets/ticketbutler_logo.png";
import CountryDialingCodeSelect from "./country_dialing_code_select.js";
import Select from "../web_modules/react-select.js";
import "./index.css";
import "./i18n/i18n.js";
const servicesStyles = {
  textBold: {
    color: "black",
    fontWeight: "bold",
    fontSize: 15,
    "@media(max-width: 500px)": {
      margin: "10px 0"
    }
  },
  textSmall: {
    margin: "0 10px 0 0",
    color: "rgb(99, 105, 109)",
    fontSize: 12,
    lineHeight: 1.4
  }
};

function getRadioInputButtonStyles(theme) {
  const buttonStyle = { ...getThemedButton(theme, {
      outline: true
    }),
    width: "68px !important",
    minWidth: "0 !important",
    height: "44px !important",
    padding: "21px 10px !important",
    "@media(max-width: 500px)": {
      width: "88px !important"
    }
  };
  return {
    "@media(max-width: 500px)": {
      width: "auto"
    },
    "> div": buttonStyle,
    "> input:checked + div": {
      backgroundColor: theme.colour_primary,
      color: theme.custom_button_text_color ? theme.custom_button_text_color : "white"
    },
    "> input": {
      opacity: "0",
      position: "absolute",
      width: "68px",
      height: "44px",
      margin: 0,
      "@media(max-width: 500px)": {
        width: "88px !important"
      }
    }
  };
}

const env = ({ url: getAbsoluteUrl('_dist_/app.js'), env: __SNOWPACK_ENV__ }).env;
const CORE_DOMAIN = env.NODE_ENV === "development" ? "//localhost:8000" : "";
export function makeTranslations(translations = {}, locale = "en") {
  return function getTranslation(messageKey, variables) {
    // Default to message key in case we don't have a translation
    let message = messageKey;

    if (locale !== "en") {
      message = getMessage(translations, locale, messageKey);
    }

    if (variables) {
      message = insertVariablesIntoMessage(message, variables);
    }

    return message;
  };
}

function getMessage(translations, locale, messageKey) {
  if (translations[locale]) {
    // We have translations for this locale
    // If we have a message for this ID use that,
    // otherwise use the ID
    return translations[locale][messageKey] || messageKey;
  } else {
    return messageKey;
  }
}

function insertVariablesIntoMessage(message, variables) {
  let completeMessage = message;

  for (const variable of variables) {
    completeMessage = completeMessage.replace("%s", variable);
  }

  return completeMessage;
}

export function makeTbRequestHeaders(language) {
  const headers = new Headers({
    "Content-Type": "application/json",
    // For POST requests
    "Accept-Language": language
  }); // TODO: This is required for logged in users, but it shouldn't be.
  // Remove when bug is solved in API

  const csrftoken = Cookie.get("csrftoken");

  if (csrftoken) {
    headers.append("X-CSRFToken", csrftoken);
  }

  return headers;
} // Point to the development server in development

export const API_HOST = env.SNOWPACK_PUBLIC_API_HOST || "/api";

if (env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://6d50327598db4a0ba662d4a35c36f836@monitor.tinyrhino.dk/8",
    //disable tracing for prod
    enableTracing: false
  });
} // Get the language from the URL.


export function useLanguage() {
  const location = useLocation();
  const lang = location.pathname.includes(`/${Language.DA}/`) ? Language.DA : Language.EN;
  return lang;
}
export const styles = {
  logo: {
    display: "block",
    maxWidth: 240,
    maxHeight: 65,
    "@media (max-width: 420px)": {
      maxWidth: 160
    }
  },
  h1: {
    fontSize: 52,
    margin: "15px 0",
    wordBreak: "break-word"
  },
  caption: {
    fontWeight: 300,
    fontSize: 15,
    color: "#63696d"
  },
  footerInfoItem: {
    display: "block",
    padding: "2.5px 0"
  },
  form: {
    maxWidth: 400,
    margin: "0 auto",
    width: "100%"
  },
  inputLabel: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 30,
    "span:first-child": {
      // The label text
      textTransform: "uppercase",
      marginBottom: 5,
      color: "#63696d",
      fontSize: 12
    }
  },
  checkboxLabel: {
    marginRight: 7.5,
    display: "flex",
    alignItems: "flex-start",
    color: "#63696d",
    fontSize: 14,
    borderRadius: 3,
    padding: 4,
    cursor: "pointer",
    "> input[type=checkbox]": {
      marginRight: 8,
      flex: "none"
    },
    "&:hover": {
      backgroundColor: "rgba(73, 157, 217, .1)",
      transition: "background-color 100ms"
    }
  },
  input: {
    padding: "10px 0 10px 10px",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#C5D0DE",
    borderRadius: 3,
    fontSize: 16
  },
  emailValdation: {
    lineHeight: "1rem",
    marginBottom: "-40px",
    fontSize: 12,
    paddingTop: 1,
    minHeight: 40
  },
  checkoutModalHeading: {
    fontWeight: "bold",
    fontSize: 15
  },
  checkoutOverviewHeading: [{
    marginTop: 25,
    marginBottom: 7.5,
    fontSize: 15,
    fontWeight: "bold",
    textTransform: "uppercase"
  }],
  textButton: {
    cursor: "pointer",
    textDecoration: "underline"
  },
  error: {
    color: "red",
    margin: 0,
    fontSize: 12
  }
};
export function getIconStyle(size) {
  return {
    width: size,
    height: size * 0.8
  };
}
export function getThemedButton(theme, options = {}) {
  let s = {
    fontFamily: theme.font_family,
    width: 230,
    height: 57,
    fontSize: 16,
    padding: "22.5px 10px",
    fontWeight: 600,
    cursor: "pointer",
    backgroundColor: theme.colour_primary,
    color: theme.custom_button_text_color ? theme.custom_button_text_color : "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    border: "none"
  };

  if (options.outline) {
    s = { ...s,
      border: "1px solid " + theme.colour_primary,
      backgroundColor: "white",
      color: theme.colour_primary
    };
  }

  return s;
}
export const isShowSeatingMap = urlParams.get("show_map") ? true : false;
export function floatIfNotRound(number) {
  // Check if we have a whole number
  const isWholeNumber = number % 1 === 0;
  if (isWholeNumber) return number.toFixed(0); // Price is not whole, so let's make sure we have 2 decimal places

  return number.toFixed(2);
}
const GlobalStyles = createGlobalStyle(({
  theme,
  isIframe
}) => {
  let css = "";
  const customFont = theme.font_family && theme.font_family.match(/'([^']+)'/);

  if (customFont) {
    const customFontName = customFont[1];
    css = css.concat(` 
        // Attempt to load Whitelabel's custom font from file
        @font-face {
          font-family: ${customFontName};
          font-weight: light;
          src: url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Light.ttf"),
            url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Light.woff2"),
            url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Light.otf");
        }
        @font-face {
          font-family: ${customFontName};
          font-weight: normal;
          src: url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Regular.ttf"),
            url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Regular.woff2"),
            url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Regular.otf");
        }
        @font-face {
          font-family: ${customFontName},
          font-weight: bold;
          src: url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Bold.ttf"),
            url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Bold.woff2"),
            url("${CORE_DOMAIN}/resources/fonts/${customFontName}/${customFontName}-Bold.otf");
        }`);
  }

  css = css.concat(`
    body {
      font-family: ${theme.font_family};
      color: ${theme.colour_font}
    }`); // For iframes, make the cookie banner position not fixed so that it doesn't
  // cause the iframe resizer to make the iframe height larger perpetually

  if (isIframe) {
    css = css.concat(`
      #cookiescript_badge, #cookiescript_injected {
        position: relative !important;
      }`);
  }

  return css;
});

var _StyledDiv = _styled("div").withConfig({
  displayName: "app___StyledDiv",
  componentId: "sc-1j24m7p-0"
})(["", ""], p => p._css);

var _StyledNav = _styled("nav").withConfig({
  displayName: "app___StyledNav",
  componentId: "sc-1j24m7p-1"
})({
  padding: 13,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
});

var _StyledImg = _styled("img").withConfig({
  displayName: "app___StyledImg",
  componentId: "sc-1j24m7p-2"
})(["", ""], p => p._css2);

var _StyledImg2 = _styled("img").withConfig({
  displayName: "app___StyledImg2",
  componentId: "sc-1j24m7p-3"
})(["", ""], p => p._css3);

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "app___StyledDiv2",
  componentId: "sc-1j24m7p-4"
})(["", ""], p => p._css4);

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "app___StyledDiv3",
  componentId: "sc-1j24m7p-5"
})({
  display: "flex",
  alignItems: "center"
});

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "app___StyledDiv4",
  componentId: "sc-1j24m7p-6"
})({
  "[data-reach-menu-item]": {
    padding: "15px 30px"
  }
});

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "app___StyledDiv5",
  componentId: "sc-1j24m7p-7"
})({
  minHeight: 35
});

var _StyledSpan = _styled("span").withConfig({
  displayName: "app___StyledSpan",
  componentId: "sc-1j24m7p-8"
})({
  textAlign: "center",
  display: "block"
});

export function App() {
  const language = useLanguage();
  const location = useLocation();
  const history = useHistory();
  const {
    path
  } = useRouteMatch();
  const {
    t
  } = useTranslation();
  const [whitelabel, setWhitelabel] = React.useState();
  const [error, setError] = React.useState(false);
  React.useEffect(function () {
    async function getWhitelabel() {
      try {
        const req = await fetch([API_HOST, "whitelabel/details/checkout/"].join("/"), {
          headers: makeTbRequestHeaders(language)
        });
        const res = await req.json();

        if (req.ok) {
          // Wait for the whitelabels' font to be fetched
          // If "font_family" does not exist or the value is not recognised
          // WebFont will not do a request and will resolve the promise.
          if (res.font_family.length > 0) {
            // See if there is a font between single quotes, indicating a
            // custom font
            const hasCustomFont = res.font_family.match(/'([^']+)'/);

            if (hasCustomFont) {
              const customFont = hasCustomFont[1].replace(/["']/g, "") + ":300,400,700";
              WebFont.load({
                google: {
                  families: [customFont]
                },
                timeout: 2000
              });
            }
          } // We are ready now


          setWhitelabel({ ...res,
            numberFormat: new Intl.NumberFormat(language, {
              style: "currency",
              currency: res.currency_code,
              currencyDisplay: "code"
            }).format
          });
        } else {
          throw res;
        }
      } catch (e) {
        setError(true);
      }
    }

    getWhitelabel();
  }, [language]);
  const theme = whitelabel !== undefined ? {
    colour_primary: whitelabel.custom_button_background_color ? whitelabel.custom_button_background_color : whitelabel.colour_primary,
    colour_secondary: whitelabel.colour_secondary,
    colour_font: whitelabel.colour_font,
    font_family: whitelabel.font_family,
    custom_button_text_color: whitelabel.custom_button_text_color
  } : undefined; //Cookie service script loading

  React.useEffect(function () {
    async function initCookieService() {
      if (({ url: getAbsoluteUrl('_dist_/app.js'), env: __SNOWPACK_ENV__ }).env.NODE_ENV !== "test" && (whitelabel?.facebook_pixel_id || whitelabel?.google_analytics_id || whitelabel?.linkedin_insight_tag) && // Users have already seen the cookie banner in the first iframe,
      // so it should not be loaded for the "full-screen" checkout modal
      // iframe
      !isCheckoutModal && //we should hide cookie banner for some organisers because they are using their own cookie script
      !whitelabel.hide_cookie_banner) {
        await loadScript({
          src: window.location.host.includes("tickethost.io") ? "https://cdn.cookie-script.com/s/9d3c456e718ba9b6dffb9d980f49932f.js" : "https://cdn.cookie-script.com/s/b846e7dc430f367a087351cd12966f78.js"
        }); // Handle cookieconsent passed via URL param for iframes

        if (isIframe && urlParams.getAll("cookieconsent").length) {
          // Delay one second to allow the CookieScript instance to initialize
          setTimeout(function () {
            if (window.CookieScript?.instance) {
              window.CookieScript.instance.acceptAction(urlParams.getAll("cookieconsent"));
            } else {
              console.error("Unable to apply cookie consent. CookieScript instance is not available.");
            }
          }, 1000);
        }
      }
    }

    initCookieService();
  }, [whitelabel?.facebook_pixel_id, whitelabel?.google_analytics_id, whitelabel?.linkedin_insight_tag, whitelabel?.hide_cookie_banner]); // Init FB pixel if it is registered for the whitelabel

  React.useEffect(function () {
    async function initFbPixel() {
      if (whitelabel && whitelabel.facebook_pixel_id) {
        // @ts-expect-error: Probaby a better way to handle this so it's not done every time
        await import("./facebook_pixel.js"); // @ts-ignore: Using global for tracking plugins

        window.fbq("init", whitelabel.facebook_pixel_id); // @ts-ignore: Using global for tracking plugins

        window.fbq("track", "PageView");
      }
    }

    initFbPixel();
  }, [whitelabel]); // Init GA4 if it is enabled for this WL

  React.useEffect(function () {
    if (whitelabel?.google_analytics_id) {
      ReactGA.initialize(whitelabel.google_analytics_id);
    }
  }, [whitelabel]);
  React.useEffect(function () {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname
    });
  }, [location]); // Init Tiktok Pixel if it is registered for the whitelabel

  React.useEffect(() => {
    async function initTiktokPixel() {
      if (whitelabel?.tiktok_pixel_id) {
        //@ts-ignore
        const tiktolPixelScript = await import("../tiktokPixelScript.js").then(v => v.default);
        tiktolPixelScript(window, document, "ttq", whitelabel?.tiktok_pixel_id);
      }
    }

    initTiktokPixel();
  }, [whitelabel?.tiktok_pixel_id]); // Init GTM for Skagenfestival (remove it when GA4 is implemented)

  React.useEffect(function () {
    if (whitelabel?.slug === "skagenfestival") {
      TagManager.initialize({
        gtmId: "GTM-W4WFR8Q"
      });
    }

    if (whitelabel?.slug === "comwell") {
      TagManager.initialize({
        gtmId: "GTM-N6K4ZNX" // This is their staging GTM container

      });
    }
  }, [whitelabel]); // Init linkedIn tracking if it is registered for the whitelabel

  React.useEffect(function () {
    if (whitelabel?.linkedin_insight_tag) {
      const linkedinTag = new LinkedInTag();
      linkedinTag.init(whitelabel.linkedin_insight_tag);
    }
  }, [whitelabel]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    _css: !isIframe && !error ? [{
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "100vh"
    }, whitelabel?.slug === "flyingsuperkids" && {
      backgroundImage: `url('https://storage.googleapis.com/cdn.ticketbutler.io/superkids_bg.jpg')`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat"
    }] : {}
  }, theme && /*#__PURE__*/React.createElement(GlobalStyles, {
    theme: theme,
    isIframe: isIframe
  }), !isIframe && /*#__PURE__*/React.createElement(_StyledNav, null, whitelabel ? whitelabel.logo ? /*#__PURE__*/React.createElement(_StyledImg, {
    src: whitelabel.logo,
    alt: whitelabel.name,
    _css2: styles.logo
  }) : /*#__PURE__*/React.createElement(_StyledImg2, {
    src: ticketbutlerLogo,
    alt: "Ticketbutler",
    _css3: styles.logo
  }) :
  /*#__PURE__*/
  // We're still fetching the whitelabel.
  React.createElement(_StyledDiv2, {
    _css4: styles.logo
  }, /*#__PURE__*/React.createElement(ContentLoader, {
    width: 200,
    height: 65
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(LanguageSelector, {
    current: language,
    onSelect: newLanguage => {
      history.push(location.pathname.replace(`/${language}/`, `/${newLanguage}/`) + makeSearchParamString());
    }
  }), // Only show the burger menu if we have items for it
  whitelabel && whitelabel.nav_items.length > 0 && /*#__PURE__*/React.createElement(Menu, null, function ({
    isOpen
  }) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MenuButton, null, /*#__PURE__*/React.createElement(Hamburger, {
      isActive: isOpen
    })), /*#__PURE__*/React.createElement(MenuPopover, null, /*#__PURE__*/React.createElement(_StyledDiv4, null, /*#__PURE__*/React.createElement(MenuItems, null, whitelabel.nav_items.map((item, index) => /*#__PURE__*/React.createElement(MenuLink, {
      key: index,
      as: "a",
      href: item.override_url || "/" + language + "/" + item.slug
    }, item.title)), whitelabel && !whitelabel.closed_platform && /*#__PURE__*/React.createElement(MenuLink, {
      as: "a",
      href: [language, "events/create-event/"].join("/"),
      style: {
        fontWeight: "bold",
        color: theme && theme.colour_primary
      }
    }, "+ ", t("event.createEvent"))))));
  }))), error && /*#__PURE__*/React.createElement(_StyledDiv5, null, /*#__PURE__*/React.createElement(_StyledSpan, null, t("event.phewApiNotRespondingTryLater"))), /*#__PURE__*/React.createElement(ErrorBoundary, {
    language: language
  }, whitelabel && theme && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: `${path}/e/:eventSlug`
  }, /*#__PURE__*/React.createElement(EventPage, {
    whitelabel: whitelabel,
    theme: theme
  })), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/r/:eventSlug/register/:ticketTypeUuid`
  }, /*#__PURE__*/React.createElement(SelfRegistration, {
    whitelabel: whitelabel,
    theme: theme
  })), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/events`
  }, /*#__PURE__*/React.createElement(EventList, {
    whitelabel: whitelabel,
    theme: theme
  }))), !isIframe && /*#__PURE__*/React.createElement(Footer, {
    whitelabel: whitelabel
  }))));
}
export const buttonCheckMark = /*#__PURE__*/React.createElement("span", {
  style: {
    fontSize: 34,
    lineHeight: 0.5
  }
}, "\u2714");
export async function cancelOrder(purchaseUUID, language) {
  // Cancel the order with Ticketbutler API
  return fetch([API_HOST, "purchases", purchaseUUID, "cancel/"].join("/"), {
    method: "POST",
    headers: makeTbRequestHeaders(language)
  });
} // Here are simple Modal components to use in iframes as ReachUIs Dialog
// component breaks focus in iframes
// In iframes we also don't need to worry about clicks outside of the modal
// because it will just take up the full view

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "app___StyledDiv6",
  componentId: "sc-1j24m7p-9"
})(p => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: p._css5,
  justifyContent: "center",
  alignItems: "flex-start"
}));

function IframeModalOverlay({
  children,
  isOpen
}) {
  React.useEffect(function () {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return function () {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(_StyledDiv6, {
    _css5: isOpen ? "flex" : "none"
  }, children);
}

var _StyledDiv7 = _styled("div").withConfig({
  displayName: "app___StyledDiv7",
  componentId: "sc-1j24m7p-10"
})(["", ""], p => p._css6);

function IframeModalContent({
  children,
  style,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv7, _extends({
    tabIndex: -1,
    role: "dialog"
  }, rest, {
    _css6: [style, {
      backgroundColor: "white",
      width: "100%",
      position: "relative",
      minHeight: "100%",
      maxHeight: "100%",
      overflow: "auto"
    }]
  }), children);
}

const ModalOverlay = isIframe ? IframeModalOverlay : DialogOverlay;
const ModalContent = isIframe ? IframeModalContent : DialogContent;

var _StyledDiv8 = _styled("div").withConfig({
  displayName: "app___StyledDiv8",
  componentId: "sc-1j24m7p-11"
})({
  position: "absolute",
  right: 0,
  top: 0,
  padding: "10px 25px",
  fontSize: 26,
  cursor: "pointer",
  userSelect: "none",
  color: "#63696d",
  zIndex: 1
});

export function RegistrationDialog({
  children,
  isOpen,
  onDismiss,
  whitelabel
}) {
  const location = useLocation();
  const language = useLanguage();
  const modalContentRef = React.useRef(null); // To hide "x" button when seating map is displayed

  const showSeatingMap = Boolean(useRouteMatch({
    path: `/${language}/e/:eventSlug/seats/`
  })); // Scroll to the top of the modal when the URL is changed. Required for small
  // devices to restore the scroll to the top of the modal.

  React.useEffect(function () {
    if (modalContentRef.current) {
      modalContentRef.current.scrollIntoView();
    }
  }, [modalContentRef, location.pathname]);
  return /*#__PURE__*/React.createElement(ModalOverlay, {
    isOpen: isOpen,
    onDismiss: // The event page is not used for seating flows that go directly to the
    // seating map, so the modal cannot be dismissed
    isShowSeatingMap ? undefined : onDismiss // Disable focus lock (thing that retains tabbing and accessibility
    // focus in the modal) on Stripe page because it prevents the 3DS form
    // from being focussed/filled
    ,
    dangerouslyBypassFocusLock: location.pathname.includes(CHECKOUT_PATHS.Payment.stripe)
  }, /*#__PURE__*/React.createElement(ModalContent, {
    ref: modalContentRef,
    "aria-label": "checkout",
    style: {
      maxWidth: "1200px",
      borderRadius: CHECKOUT_DIALOG_BORDER_RADIUS
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, // Hide close "X" for seating flows that go direct to the seating
  // map (and skip the event page)
  // Hide close "X" for housing feature
  !showSeatingMap && !isShowSeatingMap && /*#__PURE__*/React.createElement(_StyledDiv8, {
    role: "button",
    onClick: onDismiss,
    "data-testid": "checkout-modal-close-button"
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, "Close"), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\xD7")), children)));
}
export const PAYMENT_PROVIDERS = {
  STRIPE: "STRIPE",
  STRIPE_CONNECT: "STRIPE_CONNECT"
}; // A helper for setting the order summary state. The values in the summary
// table are spread out across the whole purchase object. We use this to make
// the important bits easier to see and use.

export function getOrderSummaryFromPurchase(purchase) {
  return {
    total: Number(purchase.total_and_all_fees_decimal),
    vat_total: purchase.vat_total,
    fee_total_vat: purchase.fee_total_vat,
    ticket_fee_total: purchase.fee_total,
    discount: purchase.discount_code ? purchase.discount_code.amount : null,
    discount_type: purchase.discount_code ? purchase.discount_code.discount_type : null,
    send_sms_tickets: purchase.send_sms_tickets,
    gift_card: purchase.gift_card_total !== "0.00" ? purchase.gift_card_total : null,
    service_vat: purchase.service_vat
  };
} // Used to populate the form structure when fetching the values from the API

export function getRegistraionFormValuesFromReservation(reservation) {
  const purchaseQuestionAnswerValues = reservation.purchase.purchase_answers?.answers.reduce(function (acc, answer) {
    return { ...acc,
      [answer.question]: answer.answer_value
    };
  }, {});
  return { // Populate all address related fields
    ...reservation.purchase.address,
    // Populate answered purchase questions
    ...purchaseQuestionAnswerValues // TODO: Populate answered ticket questions

  };
} // A Route wrapper to redirect users away from payment steps if they have
// already completed an order

export function PaymentRoute({
  children,
  ...props
}) {
  const {
    checkoutComplete
  } = React.useContext(CheckoutContext);
  const {
    eventSlug
  } = useParams();
  const language = useLanguage();
  return /*#__PURE__*/React.createElement(Route, props, checkoutComplete ? /*#__PURE__*/React.createElement(Redirect, {
    to: [`/${language}` + "e", eventSlug, CHECKOUT_ROUTE, "success", makeSearchParamString()].filter(Boolean).join("/")
  }) : children);
}
export function RegisterRoute({
  children,
  ...props
}) {
  const {
    checkoutComplete
  } = React.useContext(CheckoutContext);
  const {
    eventSlug,
    ticketTypeUuid
  } = useParams();
  const language = useLanguage();
  return /*#__PURE__*/React.createElement(Route, props, checkoutComplete ? /*#__PURE__*/React.createElement(Redirect, {
    to: [`/${language}`, eventSlug, "register", ticketTypeUuid, "success", makeSearchParamString()].filter(Boolean).join("/")
  }) : children);
}

var _StyledDiv9 = _styled("div").withConfig({
  displayName: "app___StyledDiv9",
  componentId: "sc-1j24m7p-12"
})(["", ""], p => p._css7);

var _StyledP = _styled("p").withConfig({
  displayName: "app___StyledP",
  componentId: "sc-1j24m7p-13"
})(["", ""], p => p._css8);

export function FieldErrors({
  errors,
  larger,
  style = {}
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv9, {
    _css7: [{
      marginTop: 5
    }, style]
  }, errors && errors.map(function (msg) {
    return /*#__PURE__*/React.createElement("div", {
      key: msg,
      className: "errorMessage"
    }, /*#__PURE__*/React.createElement(_StyledP, {
      _css8: [styles.error, larger && {
        fontSize: 16
      }, {
        margin: 0
      }]
    }, msg));
  }));
}
var CodeField;

(function (CodeField) {
  CodeField[CodeField["GiftCard"] = 0] = "GiftCard";
  CodeField[CodeField["DiscountCode"] = 1] = "DiscountCode";
})(CodeField || (CodeField = {}));

var _StyledForm = _styled("form").withConfig({
  displayName: "app___StyledForm",
  componentId: "sc-1j24m7p-14"
})(["", ""], p => p._css9);

var _StyledP2 = _styled("p").withConfig({
  displayName: "app___StyledP2",
  componentId: "sc-1j24m7p-15"
})(["", ""], p => p._css10);

var _StyledLabel = _styled("label").withConfig({
  displayName: "app___StyledLabel",
  componentId: "sc-1j24m7p-16"
})(["", ""], p => p._css11);

var _StyledDiv10 = _styled("div").withConfig({
  displayName: "app___StyledDiv10",
  componentId: "sc-1j24m7p-17"
})({
  display: "flex"
});

var _StyledInput = _styled("input").withConfig({
  displayName: "app___StyledInput",
  componentId: "sc-1j24m7p-18"
})(["", ""], p => p._css12);

var _StyledLabel2 = _styled("label").withConfig({
  displayName: "app___StyledLabel2",
  componentId: "sc-1j24m7p-19"
})(["", ""], p => p._css13);

var _StyledDiv11 = _styled("div").withConfig({
  displayName: "app___StyledDiv11",
  componentId: "sc-1j24m7p-20"
})({
  display: "flex"
});

var _StyledInput2 = _styled("input").withConfig({
  displayName: "app___StyledInput2",
  componentId: "sc-1j24m7p-21"
})(["", ""], p => p._css14);

var _StyledDiv12 = _styled("div").withConfig({
  displayName: "app___StyledDiv12",
  componentId: "sc-1j24m7p-22"
})({
  padding: "0 10px",
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "rgb(197, 208, 222)",
  borderRadius: 3
});

var _StyledP3 = _styled("p").withConfig({
  displayName: "app___StyledP3",
  componentId: "sc-1j24m7p-23"
})(["", ""], p => p._css15);

var _StyledP4 = _styled("p").withConfig({
  displayName: "app___StyledP4",
  componentId: "sc-1j24m7p-24"
})(["", ""], p => p._css16);

var _StyledDiv13 = _styled("div").withConfig({
  displayName: "app___StyledDiv13",
  componentId: "sc-1j24m7p-25"
})({
  marginTop: 15,
  "@media(max-width: 500px)": {
    flexDirection: "column",
    marginTop: 10
  }
});

var _StyledP5 = _styled("p").withConfig({
  displayName: "app___StyledP5",
  componentId: "sc-1j24m7p-26"
})(["", ""], p => p._css17);

var _StyledP6 = _styled("p").withConfig({
  displayName: "app___StyledP6",
  componentId: "sc-1j24m7p-27"
})(["", ""], p => p._css18);

var _StyledFieldset = _styled("fieldset").withConfig({
  displayName: "app___StyledFieldset",
  componentId: "sc-1j24m7p-28"
})({
  display: "flex",
  justifyContent: "center",
  marginTop: 10,
  "@media(max-width: 500px)": {
    marginTop: 15
  }
});

var _StyledLabel3 = _styled("label").withConfig({
  displayName: "app___StyledLabel3",
  componentId: "sc-1j24m7p-29"
})(["", ""], p => p._css19);

var _StyledLabel4 = _styled("label").withConfig({
  displayName: "app___StyledLabel4",
  componentId: "sc-1j24m7p-30"
})(["", ""], p => p._css20);

var _StyledLabel5 = _styled("label").withConfig({
  displayName: "app___StyledLabel5",
  componentId: "sc-1j24m7p-31"
})(["", ""], p => p._css21);

var _StyledInput3 = _styled("input").withConfig({
  displayName: "app___StyledInput3",
  componentId: "sc-1j24m7p-32"
})(["", ""], p => p._css22);

var _StyledLabel6 = _styled("label").withConfig({
  displayName: "app___StyledLabel6",
  componentId: "sc-1j24m7p-33"
})(["", ""], p => p._css23);

var _StyledInput4 = _styled("input").withConfig({
  displayName: "app___StyledInput4",
  componentId: "sc-1j24m7p-34"
})(["", ""], p => p._css24);

var _StyledDiv14 = _styled("div").withConfig({
  displayName: "app___StyledDiv14",
  componentId: "sc-1j24m7p-35"
})(["", ""], p => p._css25);

var _StyledDiv15 = _styled("div").withConfig({
  displayName: "app___StyledDiv15",
  componentId: "sc-1j24m7p-36"
})({
  display: "flex",
  flexWrap: "wrap"
});

var _StyledInput5 = _styled("input").withConfig({
  displayName: "app___StyledInput5",
  componentId: "sc-1j24m7p-37"
})(["", ""], p => p._css26);

var _StyledDiv16 = _styled("div").withConfig({
  displayName: "app___StyledDiv16",
  componentId: "sc-1j24m7p-38"
})({
  padding: "0 10px",
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "rgb(197, 208, 222)",
  borderRadius: 3
});

var _StyledP7 = _styled("p").withConfig({
  displayName: "app___StyledP7",
  componentId: "sc-1j24m7p-39"
})(["", ""], p => p._css27);

var _StyledDiv17 = _styled("div").withConfig({
  displayName: "app___StyledDiv17",
  componentId: "sc-1j24m7p-40"
})({
  display: "flex",
  flexDirection: "row",
  marginTop: 15,
  "@media(max-width: 500px)": {
    flexDirection: "column",
    marginTop: 10
  }
});

var _StyledP8 = _styled("p").withConfig({
  displayName: "app___StyledP8",
  componentId: "sc-1j24m7p-41"
})(["", ""], p => p._css28);

var _StyledFieldset2 = _styled("fieldset").withConfig({
  displayName: "app___StyledFieldset2",
  componentId: "sc-1j24m7p-42"
})({
  display: "flex",
  marginTop: 3,
  "@media(max-width: 500px)": {
    justifyContent: "center",
    marginTop: 15
  }
});

var _StyledLabel7 = _styled("label").withConfig({
  displayName: "app___StyledLabel7",
  componentId: "sc-1j24m7p-43"
})(["", ""], p => p._css29);

var _StyledLabel8 = _styled("label").withConfig({
  displayName: "app___StyledLabel8",
  componentId: "sc-1j24m7p-44"
})(["", ""], p => p._css30);

var _StyledLabel9 = _styled("label").withConfig({
  displayName: "app___StyledLabel9",
  componentId: "sc-1j24m7p-45"
})(["", ""], p => p._css31);

var _StyledLabel10 = _styled("label").withConfig({
  displayName: "app___StyledLabel10",
  componentId: "sc-1j24m7p-46"
})(["", ""], p => p._css32);

var _StyledInput6 = _styled("input").withConfig({
  displayName: "app___StyledInput6",
  componentId: "sc-1j24m7p-47"
})(["", ""], p => p._css33);

var _StyledLabel11 = _styled("label").withConfig({
  displayName: "app___StyledLabel11",
  componentId: "sc-1j24m7p-48"
})(["", ""], p => p._css34);

var _StyledTextarea = _styled("textarea").withConfig({
  displayName: "app___StyledTextarea",
  componentId: "sc-1j24m7p-49"
})(["", ""], p => p._css35);

var _StyledButton = _styled("button").withConfig({
  displayName: "app___StyledButton",
  componentId: "sc-1j24m7p-50"
})(["", ""], p => p._css36);

var _StyledButton2 = _styled("button").withConfig({
  displayName: "app___StyledButton2",
  componentId: "sc-1j24m7p-51"
})(["", ""], p => p._css37);

var _StyledP9 = _styled("p").withConfig({
  displayName: "app___StyledP9",
  componentId: "sc-1j24m7p-52"
})({
  textAlign: "center",
  color: "green",
  margin: "0px 0px 30px 0px"
});

var _StyledForm2 = _styled("form").withConfig({
  displayName: "app___StyledForm2",
  componentId: "sc-1j24m7p-53"
})({
  transition: "700ms"
});

var _StyledLabel12 = _styled("label").withConfig({
  displayName: "app___StyledLabel12",
  componentId: "sc-1j24m7p-54"
})(["", ""], p => p._css38);

var _StyledDiv18 = _styled("div").withConfig({
  displayName: "app___StyledDiv18",
  componentId: "sc-1j24m7p-55"
})({
  display: "flex"
});

var _StyledInput7 = _styled("input").withConfig({
  displayName: "app___StyledInput7",
  componentId: "sc-1j24m7p-56"
})(["", ""], p => p._css39);

var _StyledButton3 = _styled("button").withConfig({
  displayName: "app___StyledButton3",
  componentId: "sc-1j24m7p-57"
})(["", ""], p => p._css40);

var _StyledP10 = _styled("p").withConfig({
  displayName: "app___StyledP10",
  componentId: "sc-1j24m7p-58"
})({
  textAlign: "center",
  color: "green",
  margin: "0px 0px 30px 0px"
});

var _StyledForm3 = _styled("form").withConfig({
  displayName: "app___StyledForm3",
  componentId: "sc-1j24m7p-59"
})({
  transition: "700ms"
});

var _StyledLabel13 = _styled("label").withConfig({
  displayName: "app___StyledLabel13",
  componentId: "sc-1j24m7p-60"
})(["", ""], p => p._css41);

var _StyledDiv19 = _styled("div").withConfig({
  displayName: "app___StyledDiv19",
  componentId: "sc-1j24m7p-61"
})({
  display: "flex"
});

var _StyledInput8 = _styled("input").withConfig({
  displayName: "app___StyledInput8",
  componentId: "sc-1j24m7p-62"
})(["", ""], p => p._css42);

var _StyledButton4 = _styled("button").withConfig({
  displayName: "app___StyledButton4",
  componentId: "sc-1j24m7p-63"
})(["", ""], p => p._css43);

var _StyledDiv20 = _styled("div").withConfig({
  displayName: "app___StyledDiv20",
  componentId: "sc-1j24m7p-64"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  marginTop: 20
});

var _StyledButton5 = _styled("button").withConfig({
  displayName: "app___StyledButton5",
  componentId: "sc-1j24m7p-65"
})(["", ""], p => p._css44);

var _StyledP11 = _styled("p").withConfig({
  displayName: "app___StyledP11",
  componentId: "sc-1j24m7p-66"
})({
  color: "red",
  textAlign: "center"
});

var _StyledP12 = _styled("p").withConfig({
  displayName: "app___StyledP12",
  componentId: "sc-1j24m7p-67"
})({
  color: "red",
  textAlign: "center"
});

var _StyledP13 = _styled("p").withConfig({
  displayName: "app___StyledP13",
  componentId: "sc-1j24m7p-68"
})({
  color: "red",
  textAlign: "center"
});

var _StyledDiv21 = _styled("div").withConfig({
  displayName: "app___StyledDiv21",
  componentId: "sc-1j24m7p-69"
})(["", ""], p => p._css45);

export function PurchaseDetails({
  theme,
  event,
  registrationFormValues,
  reservation,
  whitelabel,
  setRegistrationFormValues,
  setOrderSummary,
  setReservation,
  onSuccess
}) {
  const language = useLanguage();
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const {
    eventSlug
  } = useParams();
  const showCAPTCHA = React.useMemo(() => {
    return reservation.purchase.purchase_is_free && !whitelabel.features.includes("disable-captcha");
  }, [reservation.purchase.purchase_is_free, whitelabel.features]);
  const [activeCodeField, setActiveCodeField] = React.useState(null);
  const [discount, setDiscount] = React.useState("");
  const [giftCard, setGiftCard] = React.useState("");
  const isExtrasEvent = urlParams.get("extras_flow");
  const [showReceiveNewsBox, setShowReceiveNewsBox] = React.useState(registrationFormValues.newsletter !== undefined);
  const [isCAPTCHAPassed, setIsCAPTCHAPassed] = React.useState(false);
  const [techError, setTechError] = React.useState(null); // @ts-ignore: We want this to be dynamic

  const customNewsletterHTML = whitelabel["newsletter_text_" + language]; // @ts-ignore: News title should be dynamic

  const customNewsTitle = whitelabel["news_title_" + language];
  const [showSMSTicketBox, setShowSMSTicketBox] = React.useState(registrationFormValues.send_sms_tickets !== undefined);
  const [firstEmail, setFirstEmail] = React.useState("");
  const [secondEmail, setSecondEmail] = React.useState("");
  const [emailsValidated, setEmailsValidated] = React.useState(null);
  const turnstile = useTurnstile();
  const defaultValueCountryCodeSelect = // The serialized purchase API
  registrationFormValues.country_dialing_code || // The query param
  registrationFormValues.country_prefix || // The whitelabel default
  whitelabel.tele_area_code;
  const {
    trigger: updatePurchase,
    status: purchaseStatus,
    reset: purchaseReset,
    lastError: purchaseLastError
  } = useAsyncStatus(async function updatePurchase(values) {
    // Server validate & update the order
    const req = await fetch([API_HOST, "purchases", reservation.purchase.uuid, `order-details/${isExtrasEvent ? "?checkout_flow=extras" : ""}`].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify(values)
    });
    const res = await req.json();

    if (req.ok) {
      // Send 'InitiateCheckout' event to Facebook if enabled
      // @ts-ignore: Get global Facebook variable
      const fbq = window.fbq;

      if (fbq) {
        fbq("track", "InitiateCheckout", {}, {
          eventID: reservation.purchase.uuid
        });
      }

      onSuccess(res);
    } else {
      if (showCAPTCHA) {
        turnstile.reset();
      } // Throw the error so they can be rendered


      setTechError(`${req.statusText ? req.statusText : "Error"}: ${req.status}`);
      throw res;
    }
  }, undefined, 2000);
  const {
    trigger: applyDiscount,
    status: APPLY_DISCOUNT_STATUS,
    reset: discountCodeReset,
    lastResult: appliedDiscount,
    lastError: discountLastError
  } = useAsyncStatus(async function applyDiscount(code) {
    // Server validate & update the order
    const req = await fetch([API_HOST, "events", event.uuid, "discount-code-apply", reservation.purchase.uuid].join("/") + "/", {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        discount_code: code
      })
    });
    const res = await req.json();

    if (req.ok) {
      setOrderSummary(summary => ({ ...summary,
        ...getOrderSummaryFromPurchase(res)
      }));
      setReservation(reservation => ({ ...reservation,
        purchase: res
      }));
      return true;
    } else {
      // Throw the error so they can be rendered
      throw res;
    }
  }, []);
  const {
    trigger: applyGiftCard,
    status: APPLY_GIFT_CARD_STATUS,
    reset: giftCardReset,
    lastResult: appliedGiftCard,
    lastError: giftCardLastError
  } = useAsyncStatus(async function applyGiftCard(cardCode) {
    // Server validate & update the order
    const req = await fetch([API_HOST, "events", event.uuid, "gift-card-code-apply", reservation.purchase.uuid].join("/") + "/", {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        gift_card: cardCode
      })
    });
    const res = await req.json();

    if (req.ok) {
      setOrderSummary(summary => ({ ...summary,
        ...getOrderSummaryFromPurchase(res)
      }));
      setReservation(reservation => ({ ...reservation,
        purchase: res
      }));
      return true;
    } else {
      // Throw the error so they can be rendered
      throw res;
    }
  }, []);
  const {
    trigger: checkIsEmailExists,
    lastResult: isEmailExists
  } = useAsyncStatus(async function checkIsEmailExists(email) {
    // Check if user with this email already registered for this event
    // and show the error message if it's true(only for free events)
    const req = await fetch([API_HOST, "events", event.uuid, "check-email", `?email=${email}`].join("/"));
    const res = await req.json();

    if (req.ok) {
      return res.exists;
    } else {
      throw res;
    }
  }, []); //reload the CAPTCHA if 100% discount applied

  React.useEffect(() => {
    if (showCAPTCHA && turnstile) {
      turnstile.reset();
    }
  }, [turnstile, showCAPTCHA]); // Check if there is a prefilled discount code and submit it

  React.useEffect(function () {
    const params = getSearchParams();
    const discountCode = registrationFormValues.discount_code || params.discount_code;

    if (discountCode) {
      applyDiscount(discountCode);
    }
  }, [registrationFormValues.discount_code, applyDiscount]);
  const validateEmail = React.useCallback(value => {
    const isEmail = value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9-]{2,63}$/i.test(value);
    const emailsMatch = firstEmail === secondEmail;

    if (!firstEmail || !secondEmail) {
      setEmailsValidated(null);
    } else if (isEmail && emailsMatch) {
      setEmailsValidated(true);
    } else {
      setEmailsValidated(false);
    }
  }, [firstEmail, secondEmail]);
  React.useEffect(() => {
    if (event.is_free_event && emailsValidated && firstEmail === secondEmail) {
      checkIsEmailExists(firstEmail);
    }
  }, [emailsValidated, checkIsEmailExists, event.is_free_event, firstEmail, secondEmail]);
  useScrollToError(Boolean(purchaseLastError || discountLastError || giftCardLastError));
  return /*#__PURE__*/React.createElement(_StyledForm, {
    onChange: purchaseReset,
    onSubmit: async function (e) {
      e.preventDefault(); // We need empty values so we can send unchecked checkboxes to the API.

      let values = serialize(e.target, {
        hash: true,
        empty: true
      }); // Check if we have an "ADDRESS" question, and get it's UUID

      const addressUUID = Object.keys(values).find(key => key === reservation?.purchase_questions?.find(question => question.variation === "ADDRESS")?.uuid); // Generate a single address string from the address fields for the API

      if (addressUUID) {
        const addressValues = values[addressUUID];
        values = { ...values,
          ...addressValues,
          [addressUUID]: `${addressValues.address_country};${addressValues.address_city};${addressValues.address_street};${addressValues.address_street_2};${addressValues.address_postcode}`
        };
      } // If the user doesn't enter a discount code, don't send it


      if (values.discount_code && values.discount_code.length < 1) {
        delete values.discount_code;
      } // Automatically apply discount code if user forgets to click 'Apply'


      if (discount && !appliedDiscount) {
        const isApplied = await applyDiscount(discount, values);

        if (isApplied === true) {
          setRegistrationFormValues(values);
          updatePurchase(values);
        }
      } // Automatically apply gift card code if user forgets to click 'Apply'


      if (giftCard && !appliedGiftCard) {
        const isApplied = await applyGiftCard(giftCard, values);

        if (isApplied === true) {
          setRegistrationFormValues(values);
          updatePurchase(values);
        }
      }

      if (!discount && !giftCard || appliedDiscount || appliedGiftCard) {
        setRegistrationFormValues(values);
        updatePurchase(values);
      }
    },
    _css9: [{
      display: "flex",
      flexDirection: "column",
      fieldset: {
        borderStyle: "none",
        paddingLeft: 0
      }
    }, styles.form]
  }, /*#__PURE__*/React.createElement(_StyledP2, {
    _css10: styles.checkoutModalHeading
  }, event.is_free_event ? t("event.provideRegistrationInfo") : t("event.provideCustomerInfo")), urlParams.get("email") !== "false" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledLabel, {
    _css11: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, "Email *"), /*#__PURE__*/React.createElement(_StyledDiv10, null, /*#__PURE__*/React.createElement(_StyledInput, {
    type: "email",
    name: "email",
    defaultValue: registrationFormValues.email,
    required: true,
    onBlur: () => validateEmail(firstEmail),
    onChange: e => {
      setFirstEmail(e.target.value);
    },
    _css12: [styles.input, {
      width: "100%",
      paddingRight: 40
    }]
  }), showIcon(emailsValidated)), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "email")
  })), /*#__PURE__*/React.createElement(_StyledLabel2, {
    _css13: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.repeat"), " Email *"), /*#__PURE__*/React.createElement(_StyledDiv11, null, /*#__PURE__*/React.createElement(_StyledInput2, {
    type: "email",
    name: "email_2",
    defaultValue: registrationFormValues.email,
    required: true,
    onBlur: () => validateEmail(secondEmail),
    onChange: e => {
      setSecondEmail(e.target.value);
      setShowReceiveNewsBox(true);
    },
    _css14: [styles.input, {
      width: "100%",
      paddingRight: 40
    }]
  }), showIcon(emailsValidated)), // Flyingsuperkids want their newsletter option as a checkbox
  // below the t&cs option
  whitelabel.slug !== "flyingsuperkids" && whitelabel.slug !== "ecs" && showReceiveNewsBox && !whitelabel.purchase_newsletter_deactivated && /*#__PURE__*/React.createElement(_StyledDiv12, null, /*#__PURE__*/React.createElement("div", null, customNewsTitle ? /*#__PURE__*/React.createElement(_StyledP3, {
    _css15: servicesStyles.textBold
  }, customNewsTitle) : /*#__PURE__*/React.createElement(_StyledP4, {
    _css16: servicesStyles.textBold
  }, t("event.receiveNewsFrom", {
    name: whitelabel.name
  })), /*#__PURE__*/React.createElement(_StyledDiv13, null, customNewsletterHTML ? /*#__PURE__*/React.createElement(_StyledP5, {
    dangerouslySetInnerHTML: {
      __html: customNewsletterHTML
    },
    _css17: servicesStyles.textSmall
  }) : /*#__PURE__*/React.createElement(_StyledP6, {
    _css18: servicesStyles.textSmall
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "event.receiveNewslettersWithUpdates",
    t: t
  }, "I would like to receive newsletters via e-mail with information about upcoming events, offers, and products from", " ", {
    name: whitelabel.slug === "billetfix" ? "Ticketbutler" : whitelabel.name
  }, ". Read the privacy policy regarding the processing", " ", /*#__PURE__*/React.createElement("a", {
    href: `https://${whitelabel.domain + "/" + language + "/privacy-policy"}`,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "here"), ". You always have the right to withdraw your consent.")), /*#__PURE__*/React.createElement(_StyledFieldset, null, /*#__PURE__*/React.createElement(_StyledLabel3, {
    _css19: [getRadioInputButtonStyles(theme), {
      marginRight: 6,
      "@media(max-width: 500px)": {
        marginRight: 15
      }
    }]
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    required: true,
    name: "newsletter",
    value: "on",
    "data-testid": "newsletter_yes",
    defaultChecked: registrationFormValues.newsletter || whitelabel.customer_information_extra_checkbox_default_checked
  }), /*#__PURE__*/React.createElement("div", null, t("event.yes"))), /*#__PURE__*/React.createElement(_StyledLabel4, {
    _css20: getRadioInputButtonStyles(theme)
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    required: true,
    name: "newsletter",
    value: "off",
    defaultChecked: registrationFormValues.newsletter === false
  }), /*#__PURE__*/React.createElement("div", null, t("event.no"))))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "newsletter")
  }))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "email_2")
  }))), urlParams.get("name") !== "false" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledLabel5, {
    _css21: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.firstName"), " *"), /*#__PURE__*/React.createElement(_StyledInput3, {
    name: "first_name",
    defaultValue: registrationFormValues.first_name,
    required: true,
    _css22: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "first_name")
  })), /*#__PURE__*/React.createElement(_StyledLabel6, {
    _css23: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.lastName"), " *"), /*#__PURE__*/React.createElement(_StyledInput4, {
    name: "last_name",
    defaultValue: registrationFormValues.last_name,
    required: true,
    _css24: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "last_name")
  }))), /*#__PURE__*/React.createElement(_StyledDiv14, {
    _css25: styles.inputLabel
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "phone"
  }, /*#__PURE__*/React.createElement("span", null, t("event.phone"), " *")), /*#__PURE__*/React.createElement(_StyledDiv15, null, /*#__PURE__*/React.createElement(CountryDialingCodeSelect, {
    defaultCode: defaultValueCountryCodeSelect
  }), /*#__PURE__*/React.createElement(_StyledInput5, {
    required: true,
    id: "phone",
    name: "phone",
    "data-testid": "phoneLong",
    defaultValue: registrationFormValues.phone,
    onChange: () => setShowSMSTicketBox(true),
    _css26: [styles.input, {
      flexGrow: 1,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }]
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "phone")
  })), showSMSTicketBox && !whitelabel.purchase_sms_deactivated && !event.eventsettings.send_attendee_sms && // No SMS for free tickets
  !reservation.purchase.purchase_is_free && // No SMS for non DK WLs
  whitelabel.country_code === "DK" && event.eventsettings.generate_ticket_pdf && /*#__PURE__*/React.createElement(_StyledDiv16, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP7, {
    _css27: servicesStyles.textBold
  }, t("event.SMSTicket"), " -", " ", whitelabel.numberFormat(whitelabel.ticket_fees_designated.fee_per_sms)), /*#__PURE__*/React.createElement(_StyledDiv17, null, /*#__PURE__*/React.createElement(_StyledP8, {
    _css28: servicesStyles.textSmall
  }, t("event.receiveSMSWithTicketLink")), /*#__PURE__*/React.createElement(_StyledFieldset2, null, /*#__PURE__*/React.createElement(_StyledLabel7, {
    _css29: [getRadioInputButtonStyles(theme), {
      marginRight: 6,
      "@media(max-width: 500px)": {
        marginRight: 15
      }
    }]
  }, /*#__PURE__*/React.createElement("input", {
    required: true,
    type: "radio",
    name: "send_sms_tickets",
    value: "on",
    "data-testid": "sms_ticket_yes",
    defaultChecked: registrationFormValues.send_sms_tickets
  }), /*#__PURE__*/React.createElement("div", null, t("event.yes"))), /*#__PURE__*/React.createElement(_StyledLabel8, {
    _css30: getRadioInputButtonStyles(theme)
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "send_sms_tickets",
    required: true,
    value: "off",
    defaultChecked: registrationFormValues.send_sms_tickets === false
  }), /*#__PURE__*/React.createElement("div", null, t("event.no"))))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "send_sms_tickets")
  })))), reservation.purchase_questions && reservation.purchase_questions.sort(sortBySortId).map(function (question) {
    let defaultValue;

    if (question.variation === "SELECT_MULTIPLE") {
      // Multiple select answers are accessed by choice uuid instead of question uuid
      // so pass the form values so each input can attempt to access it's value
      defaultValue = registrationFormValues;
    } else {
      // @ts-ignore: Ignore selecting answer values by UUID
      defaultValue = registrationFormValues[question.uuid];
    } // Hide question if all the choice limits have been reached


    if (question.variation === "SELECT_MULTIPLE" || question.variation === "SELECT") {
      if (question.choices.every(choice => {
        return choice.limit ? choice.limit <= choice.used : false;
      })) {
        return null;
      }
    }

    return /*#__PURE__*/React.createElement(_StyledLabel9, {
      key: question.uuid,
      _css31: styles.inputLabel
    }, /*#__PURE__*/React.createElement("span", null, question.heading, question.required && " *"), getInputForCustomQuestion(question, defaultValue), /*#__PURE__*/React.createElement(FieldErrors, {
      errors: getFieldError(purchaseLastError, question.uuid)
    }));
  }), reservation.has_members_only_tickets && /*#__PURE__*/React.createElement(_StyledLabel10, {
    _css32: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, event.eventsettings.members_only_text || t("event.memberCode"), " *"), /*#__PURE__*/React.createElement(_StyledInput6, {
    required: true,
    name: "members_only",
    defaultValue: registrationFormValues.members_only,
    maxLength: 35,
    _css33: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "members_only")
  })), !whitelabel.purchase_comments_deactivated && /*#__PURE__*/React.createElement(_StyledLabel11, {
    _css34: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.comments")), /*#__PURE__*/React.createElement(_StyledTextarea, {
    name: "comments",
    defaultValue: registrationFormValues.comments,
    rows: 5,
    maxLength: 1000,
    _css35: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "comments")
  })), !isExtrasEvent && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginBottom: appliedDiscount && appliedGiftCard || appliedDiscount && !whitelabel.has_gift_cards || appliedGiftCard && !event.has_discount_code ? 0 : "45px"
    }
  }, !(reservation.purchase.discount_total > 0) && event.has_discount_code && reservation.purchase.total_and_all_fees_decimal !== "0.00" && /*#__PURE__*/React.createElement(_StyledButton, {
    type: "button",
    onClick: () => {
      setActiveCodeField(CodeField.DiscountCode);
    },
    _css36: [getThemedButton(theme, {
      outline: true
    }), {
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 600,
      height: "auto",
      width: "auto",
      padding: 10,
      paddingTop: 12,
      "@media (max-width: 500px)": {
        fontSize: 10
      }
    }]
  }, activeCodeField === CodeField.DiscountCode ? t("event.discountCode") : t("event.addDiscountCode")),
  /*Spacer between Gift card code and Discount code buttons */
  reservation.purchase.gift_card_total === "0.00" && reservation.purchase.total_and_all_fees_decimal !== "0.00" && whitelabel.has_gift_cards && !(reservation.purchase.discount_total > 0) && event.has_discount_code && event.event_type !== "GIFT_CARD" && /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "25px",
      marginLeft: "25px",
      height: "auto",
      padding: "3px 0"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "rgb(211, 211, 211)",
      maxWidth: "2px",
      width: "100%",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: 0
    }
  }, "."))), reservation.purchase.gift_card_total === "0.00" && reservation.purchase.total_and_all_fees_decimal !== "0.00" && whitelabel.has_gift_cards && event.event_type !== "GIFT_CARD" && /*#__PURE__*/React.createElement(_StyledButton2, {
    type: "button",
    onClick: () => {
      setActiveCodeField(CodeField.GiftCard);
    },
    _css37: [getThemedButton(theme, {
      outline: true
    }), {
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: 600,
      height: "auto",
      width: "auto",
      padding: 10,
      paddingTop: 12,
      "@media (max-width: 500px)": {
        fontSize: 10
      }
    }]
  }, activeCodeField === CodeField.GiftCard ? t("event.giftCardCode") : t("event.addGiftCardCode"))), event.has_discount_code && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, appliedDiscount && /*#__PURE__*/React.createElement(_StyledP9, null, t("event.discountCodeApplied"), ".")), /*#__PURE__*/React.createElement(React.Fragment, null, activeCodeField === CodeField.DiscountCode && !appliedDiscount && /*#__PURE__*/React.createElement(_StyledForm2, {
    onChange: discountCodeReset,
    onSubmit: function (e) {
      e.preventDefault(); // Don't submit the parent form

      e.stopPropagation();
      const {
        discount_code
      } = serialize(e.target, {
        hash: true
      });
      applyDiscount(discount_code);
    }
  }, /*#__PURE__*/React.createElement(_StyledLabel12, {
    _css38: styles.inputLabel
  }, /*#__PURE__*/React.createElement(_StyledDiv18, null, /*#__PURE__*/React.createElement(_StyledInput7, {
    name: "discount_code",
    defaultValue: registrationFormValues.discount_code,
    maxLength: 256,
    onChange: e => setDiscount(e.target.value),
    _css39: [styles.input, {
      flexGrow: 1
    }]
  }), /*#__PURE__*/React.createElement(_StyledButton3, {
    disabled: APPLY_DISCOUNT_STATUS === AsyncStates.Pending,
    _css40: [getThemedButton(theme), {
      maxWidth: "65px",
      maxHeight: "35px",
      marginLeft: "10px"
    }]
  }, APPLY_DISCOUNT_STATUS === AsyncStates.Pending ? /*#__PURE__*/React.createElement(Spinner, {
    color: "white",
    size: 30
  }) : t("event.apply"))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(discountLastError, "discount_code")
  }))))), whitelabel.has_gift_cards && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, appliedGiftCard && /*#__PURE__*/React.createElement(_StyledP10, null, t("event.giftCardApplied"), ".")), /*#__PURE__*/React.createElement(React.Fragment, null, activeCodeField === CodeField.GiftCard && !appliedGiftCard && /*#__PURE__*/React.createElement(_StyledForm3, {
    onChange: giftCardReset,
    onSubmit: function (e) {
      e.preventDefault(); // Don't submit the parent form

      e.stopPropagation();
      const {
        gift_card
      } = serialize(e.target, {
        hash: true
      });
      applyGiftCard(gift_card);
    }
  }, /*#__PURE__*/React.createElement(_StyledLabel13, {
    _css41: styles.inputLabel
  }, /*#__PURE__*/React.createElement(_StyledDiv19, null, /*#__PURE__*/React.createElement(_StyledInput8, {
    name: "gift_card",
    defaultValue: registrationFormValues.discount_code,
    maxLength: 256,
    onChange: e => setGiftCard(e.target.value),
    _css42: [styles.input, {
      flexGrow: 1
    }]
  }), /*#__PURE__*/React.createElement(_StyledButton4, {
    disabled: APPLY_GIFT_CARD_STATUS === AsyncStates.Pending,
    _css43: [getThemedButton(theme), {
      maxWidth: "65px",
      maxHeight: "35px",
      marginLeft: "10px"
    }]
  }, APPLY_GIFT_CARD_STATUS === AsyncStates.Pending ? /*#__PURE__*/React.createElement(Spinner, {
    color: "white",
    size: 30
  }) : t("event.apply"))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(giftCardLastError, "gift_card")
  }))))), /*#__PURE__*/React.createElement(Checkbox, {
    required: true,
    name: "terms_and_conditions_agreed",
    label: /*#__PURE__*/React.createElement("span", null, t("event.iAgreeTo"), " ", /*#__PURE__*/React.createElement("a", {
      href: `/${language}/tandc/`,
      target: "_blank",
      rel: "noopener noreferrer"
    }, t("event.termsAndConditions").toLowerCase()), ".*")
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "terms_and_conditions_agreed")
  }), // Flyingsuperkids want to show the newsletter option as a checkbox at
  // the bottom. Everyone else gets the normal Yes/No option below the
  // email inputs
  (whitelabel.slug === "flyingsuperkids" || whitelabel.slug === "ecs") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    name: "newsletter",
    initialChecked: whitelabel.customer_information_extra_checkbox_default_checked,
    label: customNewsletterHTML ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: customNewsletterHTML
      }
    }) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "event.receiveNewslettersWithUpdates",
      t: t
    }, "I would like to receive newsletters via e-mail with information about upcoming events, offers, and products from", " ", {
      name: whitelabel.name
    }, ". Read the privacy policy regarding the processing", " ", /*#__PURE__*/React.createElement("a", {
      href: `https://${whitelabel.domain + "/" + language + "/privacy-policy"}`,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "here"), ". You always have the right to withdraw your consent."))
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "newsletter")
  })), /*#__PURE__*/React.createElement(_StyledDiv20, null, showCAPTCHA && env.SNOWPACK_PUBLIC_TURNSTILE_SITE_KEY && /*#__PURE__*/React.createElement(Turnstile, {
    sitekey: env.SNOWPACK_PUBLIC_TURNSTILE_SITE_KEY,
    appearance: "always",
    theme: "light",
    fixedSize: true,
    onVerify: () => {
      setIsCAPTCHAPassed(true);
    }
  }), /*#__PURE__*/React.createElement(LoadingButton, {
    loading: purchaseStatus === AsyncStates.Pending || APPLY_DISCOUNT_STATUS === AsyncStates.Pending,
    success: purchaseStatus === AsyncStates.Success,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton5, {
    disabled: showCAPTCHA && turnstile && !isCAPTCHAPassed,
    type: "submit",
    _css44: [getThemedButton(theme), {
      marginTop: 15,
      backgroundColor: showCAPTCHA && turnstile && !isCAPTCHAPassed ? "lightgrey" : theme.colour_primary
    }]
  }, t("event.continue"))), purchaseLastError instanceof Error ? /*#__PURE__*/React.createElement(_StyledP11, null, t("event.errorTryAgain")) : purchaseLastError?.non_field_errors && /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(purchaseLastError, "non_field_errors")
  }), techError && /*#__PURE__*/React.createElement(_StyledP12, {
    className: "errorMessage"
  }, techError, "."), isEmailExists && /*#__PURE__*/React.createElement(_StyledP13, null, t("event.youAlreadyHaveTicket"), "."), /*#__PURE__*/React.createElement(_StyledDiv21, {
    role: "button",
    onClick: function () {
      if (reservation.purchase.has_active_extras_types || event.has_seating) {
        history.goBack();
      } else {
        history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
      }
    },
    _css45: [styles.textButton, {
      color: "#63696d",
      marginTop: 10,
      fontSize: 12
    }]
  }, t("event.back"))));
}

var _StyledForm4 = _styled("form").withConfig({
  displayName: "app___StyledForm4",
  componentId: "sc-1j24m7p-70"
})(["", ""], p => p._css46);

var _StyledDiv22 = _styled("div").withConfig({
  displayName: "app___StyledDiv22",
  componentId: "sc-1j24m7p-71"
})({
  margin: "30px 0"
});

var _StyledP14 = _styled("p").withConfig({
  displayName: "app___StyledP14",
  componentId: "sc-1j24m7p-72"
})({
  fontSize: 14,
  borderBottom: "1px solid #E2E2E2"
});

var _StyledSpan2 = _styled("span").withConfig({
  displayName: "app___StyledSpan2",
  componentId: "sc-1j24m7p-73"
})({
  color: "#63696d"
});

var _StyledLabel14 = _styled("label").withConfig({
  displayName: "app___StyledLabel14",
  componentId: "sc-1j24m7p-74"
})(["", ""], p => p._css47);

var _StyledDiv23 = _styled("div").withConfig({
  displayName: "app___StyledDiv23",
  componentId: "sc-1j24m7p-75"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
});

var _StyledButton6 = _styled("button").withConfig({
  displayName: "app___StyledButton6",
  componentId: "sc-1j24m7p-76"
})(["", ""], p => p._css48);

var _StyledP15 = _styled("p").withConfig({
  displayName: "app___StyledP15",
  componentId: "sc-1j24m7p-77"
})({
  color: "red",
  textAlign: "center"
});

var _StyledDiv24 = _styled("div").withConfig({
  displayName: "app___StyledDiv24",
  componentId: "sc-1j24m7p-78"
})(["", ""], p => p._css49);

export function AttendeeQuestions({
  theme,
  event,
  reservation,
  registrationFormValues,
  setRegistrationFormValues,
  onSuccess
}) {
  const history = useHistory();
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const {
    trigger: saveAnswers,
    status,
    reset,
    lastError
  } = useAsyncStatus(async function updatePurchase(values) {
    // Server validate & update the order
    const req = await fetch([API_HOST, "purchases", reservation.purchase.uuid, "order-ticket-questions/"].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify(values)
    });

    if (req.ok) {
      onSuccess();
    } else {
      const res = await req.json();
      throw res;
    }
  }, undefined, 2000);
  const defaultValueCountryCodeSelect = (reservation.purchase.address?.phone_country_prefix ? "+" + reservation.purchase.address.phone_country_prefix : false) || // The serialized purchase API
  registrationFormValues.country_dialing_code || // The query param
  registrationFormValues.country_prefix;
  useScrollToError(Boolean(lastError));
  return /*#__PURE__*/React.createElement(_StyledForm4, {
    onChange: reset,
    onSubmit: function (e) {
      e.preventDefault();
      const values = serialize(e.target, {
        hash: true
      }); // Retain the values in case the user goes somewhere and wants to come back

      setRegistrationFormValues(v => ({ ...v,
        ...values
      })); // Try to save the answers

      saveAnswers(values);
    },
    _css46: styles.form
  }, reservation.ticket_questions // Filter out tickets which do not have any questions for their ticket type
  .filter(({
    questions
  }) => questions.length > 0).map(function (ticketTypeQuestionGroup, ticketIndex) {
    const questionGroupErrors = lastError ? // @ts-ignore: Dynamic error access is ok - the UUIDs are dynamic
    lastError[ticketTypeQuestionGroup.uuid] : null;
    return /*#__PURE__*/React.createElement(_StyledDiv22, {
      key: ticketTypeQuestionGroup.uuid
    }, /*#__PURE__*/React.createElement(_StyledP14, null, /*#__PURE__*/React.createElement(_StyledSpan2, null, event.eventsettings.generate_ticket_pdf !== false ? event.event_type === "GIFT_CARD" ? t("event.giftCard") : t("event.ticket") : t("event.reservationNumber"), " ", ticketIndex + 1, " "), " ", ticketTypeQuestionGroup.ticket_type_name), ticketTypeQuestionGroup.questions.sort(sortBySortId).map(function (question, i) {
      let defaultValue;

      if (question.variation === "SELECT_MULTIPLE") {
        // Multiple select answers are accessed by choice uuid instead of question uuid
        // so pass the form values so each input can attempt to access it's value
        defaultValue = registrationFormValues;
      } else if (ticketIndex === 0) {
        if (question.variation === "NAME") {
          defaultValue = [reservation.purchase.address?.first_name, reservation.purchase.address?.last_name].join(" ");
        } else if (question.variation === "NAME_FIRST_LAST") {
          defaultValue = [reservation.purchase.address?.first_name, reservation.purchase.address?.last_name];
        } else if (question.variation === "COMPANY") {
          defaultValue = reservation.purchase_answers?.find(answer => answer.variation === "COMPANY")?.answer_value;
        } else if (question.variation === "EMAIL") {
          defaultValue = reservation.purchase.address?.email;
        } else if (question.variation === "PHONE") {
          defaultValue = reservation.purchase.address?.phone.replace(defaultValueCountryCodeSelect || "", "");
        }
      } else {
        // @ts-ignore: Ignore selecting answer values by UUID
        defaultValue = registrationFormValues[question.uuid];
      } // Hide question if all the choice limits have been reached


      if (question.variation === "SELECT_MULTIPLE" || question.variation === "SELECT") {
        if (question.choices.every(choice => {
          return choice.limit ? choice.limit <= choice.used : false;
        })) {
          return null;
        }
      }

      return /*#__PURE__*/React.createElement(_StyledLabel14, {
        key: question.uuid,
        _css47: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, question.heading, question.required && " *"), getInputForCustomQuestion(question, defaultValue, defaultValueCountryCodeSelect), /*#__PURE__*/React.createElement(FieldErrors, {
        errors: getFieldError(questionGroupErrors, question.uuid)
      }));
    }));
  }), /*#__PURE__*/React.createElement(_StyledDiv23, null, /*#__PURE__*/React.createElement(LoadingButton, {
    loading: status === AsyncStates.Pending,
    success: status === AsyncStates.Success,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton6, {
    type: "submit",
    _css48: [getThemedButton(theme), {
      marginTop: 15
    }]
  }, !reservation.purchase.purchase_is_free ? t("event.continue") : t("event.register"))), lastError instanceof Error && /*#__PURE__*/React.createElement(_StyledP15, {
    className: "errorMessage"
  }, t("event.errorTryAgain"), "."), /*#__PURE__*/React.createElement(_StyledDiv24, {
    role: "button",
    onClick: function () {
      history.goBack();
    },
    _css49: [styles.textButton, {
      color: "#63696d",
      marginTop: 10,
      fontSize: 12
    }]
  }, t("event.back"))));
}

var _StyledDiv25 = _styled("div").withConfig({
  displayName: "app___StyledDiv25",
  componentId: "sc-1j24m7p-79"
})({
  textAlign: "center"
});

var _StyledH = _styled("h1").withConfig({
  displayName: "app___StyledH",
  componentId: "sc-1j24m7p-80"
})({
  fontWeight: 400,
  letterSpacing: 2,
  marginTop: 0,
  marginBottom: 40,
  "@media (max-width: 420px)": {
    fontSize: 26
  }
});

var _StyledP16 = _styled("p").withConfig({
  displayName: "app___StyledP16",
  componentId: "sc-1j24m7p-81"
})(["", ""], p => p._css50);

var _StyledSpan3 = _styled("span").withConfig({
  displayName: "app___StyledSpan3",
  componentId: "sc-1j24m7p-82"
})({
  fontWeight: "bold",
  marginTop: 15
});

var _StyledP17 = _styled("p").withConfig({
  displayName: "app___StyledP17",
  componentId: "sc-1j24m7p-83"
})({
  fontSize: "14px"
});

var _StyledP18 = _styled("p").withConfig({
  displayName: "app___StyledP18",
  componentId: "sc-1j24m7p-84"
})({
  fontSize: "14px"
});

var _StyledA = _styled("a").withConfig({
  displayName: "app___StyledA",
  componentId: "sc-1j24m7p-85"
})({
  textDecoration: "none"
});

var _StyledButton7 = _styled("button").withConfig({
  displayName: "app___StyledButton7",
  componentId: "sc-1j24m7p-86"
})(["", ""], p => p._css51);

var _StyledDiv26 = _styled("div").withConfig({
  displayName: "app___StyledDiv26",
  componentId: "sc-1j24m7p-87"
})({
  display: "flex",
  justifyContent: "center "
});

var _StyledP19 = _styled("p").withConfig({
  displayName: "app___StyledP19",
  componentId: "sc-1j24m7p-88"
})({
  fontSize: "14px"
});

var _StyledP20 = _styled("p").withConfig({
  displayName: "app___StyledP20",
  componentId: "sc-1j24m7p-89"
})({
  fontSize: "14px"
});

var _StyledDiv27 = _styled("div").withConfig({
  displayName: "app___StyledDiv27",
  componentId: "sc-1j24m7p-90"
})({
  backgroundColor: "#F9F9FC",
  width: "100%",
  maxWidth: 600,
  margin: "0 auto",
  padding: "10px 0",
  fontSize: "14px"
});

var _StyledSpan4 = _styled("span").withConfig({
  displayName: "app___StyledSpan4",
  componentId: "sc-1j24m7p-91"
})({
  display: "block"
});

export function PurchaseSuccess({
  theme,
  event,
  purchase,
  paymentByInvoice = false,
  whitelabel
}) {
  const language = useLanguage();
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const {
    warnBeforeExit,
    setCheckoutContext
  } = React.useContext(CheckoutContext); // We need to tell the Tickbutler API that the user is now back from
  // or has completed the payment step, so the state can be updated to WAITING.
  // For free payments we also need to tell the API that the user has reached
  // the success page.

  React.useEffect(function () {
    async function confirmPaymentCompleted() {
      if (purchase.state === "PAYGATEWAY") {
        // TODO: We could add a loading state and re-try here if there's
        // an error with this request?
        reportPaymentStepSuccessful(language, purchase.uuid);
      }
    }

    confirmPaymentCompleted();
  }, [purchase, language]);
  const [pdfUrl, setPdfUrl] = React.useState();
  const pdfRequestTimeoutRef = React.useRef();
  const getPdfUrl = React.useCallback(async function () {
    const req = await fetch([API_HOST, "purchases", purchase.uuid, "pdf/"].join("/"));

    switch (req.status) {
      case 500:
        break;

      case 202:
        {
          const res = await req.json();
          setPdfUrl(res);
          break;
        }

      default:
        pdfRequestTimeoutRef.current = window.setTimeout(getPdfUrl, 2000);
    }
  }, [purchase.uuid]);
  React.useEffect(() => {
    if ( // Load the PDF url only if tickets will be generated
    event.eventsettings.generate_ticket_pdf) {
      getPdfUrl();
    }

    return function () {
      if (pdfRequestTimeoutRef.current) clearTimeout(pdfRequestTimeoutRef.current);
    };
  }, [event.eventsettings.generate_ticket_pdf, getPdfUrl]);
  React.useEffect(function () {
    // If the warning for closing the checkout modal is still active, disable
    // it.
    if (warnBeforeExit) {
      setCheckoutContext(s => ({ ...s,
        warnBeforeExit: false,
        checkoutComplete: true
      }));
    }
  }, [setCheckoutContext, warnBeforeExit]);
  React.useEffect(function () {
    // Send a purchase event to Facebook Pixel (if one has been initiated)
    // Required for iframe users, as a PageView is not correctly recoreded in that context.
    // @ts-ignore: Get global Facebook variable
    const fbq = window.fbq;

    if (fbq) {
      fbq("track", "Purchase", {
        // Required feilds
        currency: whitelabel.currency_code,
        value: purchase.total_and_all_fees_decimal,
        // Optional, "standard" Facebook Purchase properties
        content_name: event.title,
        num_items: purchase.total_amount,
        // Extra Fields
        event_uuid: event.uuid,
        vat_total: purchase.vat_total,
        fee_total: purchase.fee_total
      }, {
        eventID: purchase.uuid
      });
    }
  }, [purchase, event.title, event.uuid, whitelabel.currency_code]); //Send purchase success to TikTok Pixel

  React.useEffect(() => {
    if (whitelabel?.tiktok_pixel_id) {
      window.ttq.track("CompletePayment");
    }
  }, [whitelabel?.tiktok_pixel_id]); //Send purchase success to GA

  React.useEffect(() => {
    if (whitelabel?.google_analytics_id) {
      ReactGA.gtag("event", "purchase", {
        currency: whitelabel.currency_code,
        transaction_id: purchase.uuid,
        coupon: purchase.discount_code?.code,
        discount_total: purchase.discount_total,
        value: Number(purchase.total_and_all_fees_decimal),
        tax: Number(purchase.vat_total) + Number(purchase.service_vat),
        items: purchase.tickets.map(ticket => {
          return {
            item_id: ticket.tickets[0].ticket_type_pk.toString(),
            item_name: ticket.tickets[0].ticket_type_name,
            quantity: ticket.amount,
            price: ticket.tickets[0].price
          };
        })
      });
    }
  }, [whitelabel, purchase]);
  return /*#__PURE__*/React.createElement(_StyledDiv25, null, event.eventsettings.purchase_success_text_en != null && event.eventsettings.purchase_success_text_en != "" && language === Language.EN ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: event.eventsettings.purchase_success_text_en
    }
  }) : event.eventsettings.purchase_success_text_da != null && event.eventsettings.purchase_success_text_da != "" && language === Language.DA ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: event.eventsettings.purchase_success_text_da
    }
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledH, null, purchase.purchase_is_free && event.event_type !== "GIFT_CARD" ? t("event.registrationSuccessful").toUpperCase() : t("event.purchaseSuccessful").toUpperCase()), /*#__PURE__*/React.createElement(React.Fragment, null, event.event_type !== "GIFT_CARD" && /*#__PURE__*/React.createElement(_StyledP16, {
    _css50: [{
      marginBottom: 30,
      fontSize: "14px"
    }]
  }, event.eventsettings.has_season_tickets ? purchase.total_amount === 1 ? t("event.secureSeasonTicket") : t("event.secureSeasonTickets") : purchase.total_amount === 1 ? t("event.secureTicket") : t("event.secureTickets"), " ", /*#__PURE__*/React.createElement(_StyledSpan3, null, event.title), "."), paymentByInvoice && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("strong", null, t("event.payByInvoiceRemark"), "."), /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement(_StyledP17, null, event.event_type === "GIFT_CARD" ? purchase.total_amount === 1 ? t("event.giftCardWillBeSentTo") : t("event.giftCardsWillBeSentTo") : event.eventsettings.has_season_tickets ? purchase.total_amount === 1 ? t("event.seasonTicketWillBeSentTo") : t("event.seasonTicketsWillBeSentTo") : purchase.total_amount === 1 ? t("event.ticketWillBeSentTo") : t("event.ticketsWillBeSentTo"), " ", /*#__PURE__*/React.createElement("strong", null, purchase.email), " ", t("event.withinAFewMinutes"), "."), /*#__PURE__*/React.createElement(_StyledP18, null, event.event_type === "GIFT_CARD" ? "" : event.eventsettings.has_season_tickets ? purchase.total_amount === 1 ? t("event.showSeasonTicketOnSmartphone") : t("event.showSeasonTicketsOnSmartphone") : purchase.total_amount === 1 ? t("event.showTicketOnSmartphone") : t("event.showTicketsOnSmartphone"), "."))), event.eventsettings.generate_ticket_pdf && (pdfUrl ? /*#__PURE__*/React.createElement(_StyledA, {
    href: pdfUrl,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(_StyledButton7, {
    _css51: [getThemedButton(theme), {
      margin: "30px auto"
    }]
  }, event.eventsettings.attach_voucher || event.event_type === "GIFT_CARD" ? purchase.total_amount === 1 ? t("event.downloadGiftCard") : t("event.downloadGiftCards") : event.eventsettings.has_season_tickets ? purchase.total_amount === 1 ? t("event.downloadSeasonTicket") : t("event.downloadSeasonTickets") : purchase.total_amount === 1 ? t("event.downloadTicket") : t("event.downloadTickets"))) : /*#__PURE__*/React.createElement(_StyledDiv26, null, /*#__PURE__*/React.createElement(Spinner, {
    color: theme.colour_primary
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP19, null, event.event_type === "GIFT_CARD" ? purchase.total_amount === 1 ? t("event.sendGiftCard") : t("event.sendGiftCards") : event.eventsettings.has_season_tickets ? purchase.total_amount === 1 ? t("event.sendSeasonTicket") : t("event.sendSeasonTickets") : purchase.total_amount === 1 ? t("event.sendTicket") : t("event.sendTickets")), /*#__PURE__*/React.createElement(_StyledP20, null, t("event.checkSpamFolder"), ".")), /*#__PURE__*/React.createElement(_StyledDiv27, null, /*#__PURE__*/React.createElement("p", null, event.eventsettings.generate_ticket_pdf !== false && !event.is_free_event ? t("event.haveBeenSentTo", {
    items: event.eventsettings.attach_voucher || event.event_type === "GIFT_CARD" ? t("event.giftCards") : t("event.tickets")
  }) : t("event.confirmationSentTo"), ": ", /*#__PURE__*/React.createElement(_StyledSpan4, null, purchase.email), " "), /*#__PURE__*/React.createElement("p", null, event.is_free_event ? t("event.registrationNumber") : t("event.orderNumber"), ": ", /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block"
    }
  }, purchase.id), " ")));
}
export async function reportPaymentStepSuccessful(language, purchaseUUID) {
  return await fetch([API_HOST, "purchases", purchaseUUID, "quickpay"].join("/") + "/", {
    method: "POST",
    headers: makeTbRequestHeaders(language)
  });
}

var _StyledSpan5 = _styled("span").withConfig({
  displayName: "app___StyledSpan5",
  componentId: "sc-1j24m7p-92"
})(["", ""], p => p._css52);

export function Countdown({
  seconds,
  onEnd
}) {
  const location = useLocation();
  const [secondsElapsed, setSecondsElapsed] = React.useState(0);
  const interval = React.useRef();
  React.useEffect(() => {
    interval.current = window.setInterval(() => {
      setSecondsElapsed(s => s + 1);
    }, 1000);
    return () => clearInterval(interval.current);
  }, []);
  const countdownComplete = seconds <= secondsElapsed;
  React.useEffect(function () {
    if (countdownComplete) {
      // We have reached 0
      clearInterval(interval.current);
      onEnd();
    }
  }, [onEnd, countdownComplete]); // Reset when user completes an interaction

  React.useEffect(function () {
    setSecondsElapsed(0);
  }, [location]);
  const secondsRemaining = seconds - secondsElapsed;
  const minutesRemaining = secondsRemaining / 60;
  const displayedMinutes = Math.floor(minutesRemaining);
  const displayedSeconds = ((minutesRemaining - displayedMinutes) * 60).toFixed(0);
  return /*#__PURE__*/React.createElement(_StyledSpan5, {
    _css52: [{
      fontWeight: "bold"
    }, secondsRemaining < seconds / 3 && secondsElapsed !== seconds ? {
      color: "red",
      "@keyframes pulse": {
        to: {
          fontWeight: "normal"
        }
      },
      animation: "1s 2s infinite pulse"
    } : {}, secondsElapsed === 0 && {
      color: "green",
      transition: "500ms all"
    }]
  }, displayedMinutes, ":", parseInt(displayedSeconds) < 10 ? "0" + displayedSeconds : displayedSeconds);
}

var _StyledDiv28 = _styled("div").withConfig({
  displayName: "app___StyledDiv28",
  componentId: "sc-1j24m7p-93"
})({
  display: "flex",
  justifyContent: "center "
});

export function MobilePayCheckout({
  purchaseUUID,
  theme,
  urlParameters
}) {
  const {
    setCheckoutContext
  } = React.useContext(CheckoutContext);
  const language = useLanguage(); // In case the browser blocks the auto-redirect, store it so the user can
  // navigate via a link

  const {
    trigger: getMobilePayLink,
    status,
    lastResult: redirectUrl,
    lastError
  } = useAsyncStatus(async function getPaymentLink() {
    // Wait for both MobilePay payment url request and state to update
    const [req] = await Promise.all([fetch([API_HOST, "purchases", purchaseUUID, "mobilepay/"].join("/") + urlParameters, {
      method: "POST",
      headers: makeTbRequestHeaders(language)
    }), // Ensure we will not show the window close warning before redirecting
    setCheckoutContext(s => ({ ...s,
      warnBeforeExit: false
    }))]);
    const res = await req.json();

    if (req.ok) {
      if (res.payment_link) {
        //   // Take user to Mobile Pay
        window.location.assign(res.payment_link);
        return res.payment_link;
      }
    } else {
      throw res;
    }
  });
  React.useEffect(function () {
    getMobilePayLink();
  }, [getMobilePayLink]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !redirectUrl && /*#__PURE__*/React.createElement(_StyledDiv28, null, /*#__PURE__*/React.createElement(Spinner, {
    color: theme.colour_primary
  })));
}

var _StyledDiv29 = _styled("div").withConfig({
  displayName: "app___StyledDiv29",
  componentId: "sc-1j24m7p-94"
})({
  marginTop: "10%",
  padding: 10,
  textAlign: "center"
});

var _StyledP21 = _styled("p").withConfig({
  displayName: "app___StyledP21",
  componentId: "sc-1j24m7p-95"
})(["", ""], p => p._css53);

var _StyledDiv30 = _styled("div").withConfig({
  displayName: "app___StyledDiv30",
  componentId: "sc-1j24m7p-96"
})({
  marginTop: 20
});

var _StyledDiv31 = _styled("div").withConfig({
  displayName: "app___StyledDiv31",
  componentId: "sc-1j24m7p-97"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
});

var _StyledButton8 = _styled("button").withConfig({
  displayName: "app___StyledButton8",
  componentId: "sc-1j24m7p-98"
})(["", ""], p => p._css54);

var _StyledA2 = _styled("a").withConfig({
  displayName: "app___StyledA2",
  componentId: "sc-1j24m7p-99"
})(["", ""], p => p._css55);

var _StyledP22 = _styled("p").withConfig({
  displayName: "app___StyledP22",
  componentId: "sc-1j24m7p-100"
})({
  color: "red"
});

export function QuickPay({
  purchaseUUID,
  theme,
  urlParameters,
  whitelabel
}) {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    eventSlug
  } = useParams();
  const {
    setCheckoutContext
  } = React.useContext(CheckoutContext);
  const language = useLanguage();
  const {
    isDetailIframe
  } = useIframeTypes(whitelabel); // In case the browser blocks the auto-redirect, store it so the user can
  // navigate via a link

  const {
    trigger: getPaymentLink,
    status,
    lastResult: redirectUrl,
    lastError
  } = useAsyncStatus(async function getPaymentLink() {
    // Wait for both QP url request and state to update
    const [req] = await Promise.all([fetch([API_HOST, "purchases", purchaseUUID, "quickpay/"].join("/") + urlParameters || "", {
      headers: makeTbRequestHeaders(language)
    }), // Ensure we will not show the window close warning before redirecting
    setCheckoutContext(s => ({ ...s,
      warnBeforeExit: false
    }))]);
    const res = await req.json();

    if (req.ok) {
      if (res.payment_link) {
        // For detail iframes, send a message to the parent that we are going
        // to an external payment. We do this because the iframe loads a new
        // URL and causes a "flash" before it loads
        if (isDetailIframe) {
          parent.postMessage({
            type: "TICKETBUTLER_EXTERNAL_PAYMENT",
            active: true
          }, "*");
        } // Take user to QuickPay


        window.location.assign(res.payment_link);
        return res.payment_link;
      }
    } else {
      // The address is missing or incomplete, show an alert and redirect to
      // the purchase information page
      if (res.address) {
        window.confirm("Address information is missing or incomplete. We will take you back to the address form.");
        history.push([`/${language}/e`, eventSlug, "checkout", makeSearchParamString()].filter(Boolean).join("/"));
      }

      throw res;
    }
  });
  useScrollToError(Boolean(lastError));
  React.useEffect(function () {
    getPaymentLink();
  }, [getPaymentLink]);
  return /*#__PURE__*/React.createElement(_StyledDiv29, null, /*#__PURE__*/React.createElement(_StyledP21, {
    _css53: styles.checkoutModalHeading
  }, /*#__PURE__*/React.createElement("strong", null, t("event.openPaymentWindow"), "...")), /*#__PURE__*/React.createElement(_StyledDiv30, null, /*#__PURE__*/React.createElement("p", null, t("event.notAutomaticallyTakeToPaymentWindow"), ":"), /*#__PURE__*/React.createElement(_StyledDiv31, null, /*#__PURE__*/React.createElement(LoadingButton, {
    loading: !redirectUrl && !lastError
  }, lastError ? /*#__PURE__*/React.createElement(_StyledButton8, {
    onClick: function () {
      getPaymentLink();
    },
    _css54: getThemedButton(theme)
  }, t("event.tryAgain")) : /*#__PURE__*/React.createElement(_StyledA2, {
    href: redirectUrl || undefined,
    _css55: [getThemedButton(theme), {
      textDecoration: "none"
    }]
  }, t("event.continue")))), status === AsyncStates.Error && lastError && (lastError instanceof Error ? /*#__PURE__*/React.createElement(_StyledP22, {
    className: "errorMessage"
  }, t("event.errorMessage"), ".") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "non_field_errors")
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "address")
  })))));
}

var _StyledButton9 = _styled("button").withConfig({
  displayName: "app___StyledButton9",
  componentId: "sc-1j24m7p-101"
})(["", ""], p => p._css56);

export function PurchaseCancelled({
  theme,
  purchase
}) {
  const {
    t
  } = useTranslation();
  const language = useLanguage();
  const {
    setCheckoutContext
  } = React.useContext(CheckoutContext);
  const {
    eventSlug
  } = useParams();
  const history = useHistory();
  React.useEffect(function () {
    // Disable modal close warning
    setCheckoutContext(s => ({ ...s,
      warnBeforeExit: false,
      checkoutComplete: true
    })); // Cancel the payment with Ticketbutler

    cancelOrder(purchase.uuid, language);
  }, [purchase.uuid, setCheckoutContext, language]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, purchase.state === "WAITINGLIST" ? /*#__PURE__*/React.createElement("strong", null, t("event.cancelledNotification"), ".") : !purchase.purchase_is_free ? /*#__PURE__*/React.createElement("strong", null, t("event.cancelledPayment"), ".") : /*#__PURE__*/React.createElement("strong", null, t("event.cancelledRegistration"), ".")), /*#__PURE__*/React.createElement(_StyledButton9, {
    onClick: function () {
      history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
    },
    _css56: getThemedButton(theme)
  }, t("event.backToEventPage")));
}

var _StyledForm5 = _styled("form").withConfig({
  displayName: "app___StyledForm5",
  componentId: "sc-1j24m7p-102"
})(["", ""], p => p._css57);

var _StyledP23 = _styled("p").withConfig({
  displayName: "app___StyledP23",
  componentId: "sc-1j24m7p-103"
})(["", ""], p => p._css58);

var _StyledDiv32 = _styled("div").withConfig({
  displayName: "app___StyledDiv32",
  componentId: "sc-1j24m7p-104"
})({
  boxShadow: "rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px",
  padding: "15px 14px",
  fontSize: "1em",
  border: 0,
  margin: "20px 0",
  maxWidth: 500,
  outline: 0,
  borderRadius: 4
});

var _StyledDiv33 = _styled("div").withConfig({
  displayName: "app___StyledDiv33",
  componentId: "sc-1j24m7p-105"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 35
});

var _StyledButton10 = _styled("button").withConfig({
  displayName: "app___StyledButton10",
  componentId: "sc-1j24m7p-106"
})(["", ""], p => p._css59);

var _StyledP24 = _styled("p").withConfig({
  displayName: "app___StyledP24",
  componentId: "sc-1j24m7p-107"
})({
  color: "red",
  textAlign: "center"
});

const StripeForm = ({
  theme,
  ticketbutlerApiUrl,
  clientSecret,
  whitelabel
}) => {
  const checkoutNavigate = useCheckoutNavigate();
  const {
    t
  } = useTranslation();
  const language = useLanguage();
  const {
    setCheckoutContext
  } = React.useContext(CheckoutContext);
  const [stripePaymentConfirmed, setStripePaymentConfirmed] = React.useState(false);
  const {
    eventSlug
  } = useParams(); //stripe elements hooks

  const stripe = useStripe();
  const elements = useElements(); // Here the user coulddo a few things (such as use the Back/Forward buttons in the
  // browser to navigate away from this page. The Stripe modal will not know about these
  // actions and will not be removed from the screen. Therefore, let's ensure the modal is
  // removed when this component is unmounted.

  React.useEffect(function () {
    return function () {
      try {
        const containers = [...document.getElementsByTagName("iframe")].filter(item => item.name?.indexOf("__privateStripeFrame") === 0 && item.src?.includes("/authorize")).map(item => item.parentElement);
        const container = containers[0];

        if (container && container.parentElement) {
          container.parentElement.removeChild(container);
        }
      } catch (e) {
        console.warn("Ticketbutler: Attempted to remove Stripe iframe from the DOM, however it was not found.");
      }
    };
  }, []);
  const {
    trigger: makePayment,
    status,
    lastError
  } = useAsyncStatus(async function makePayment() {
    if (stripe && elements && clientSecret) {
      if (!stripePaymentConfirmed) {
        // Trigger form validation and wallet collection
        const {
          error: submitError
        } = await elements.submit();

        if (submitError) {
          // Show error to your customer
          throw submitError.message;
        }

        setCheckoutContext(s => ({ ...s,
          warnBeforeExit: false
        })); // Confirm payment with stripe API

        const stripeResponse = await stripe.confirmPayment({
          elements,
          clientSecret,
          redirect: "if_required",
          confirmParams: {
            return_url: [`https://${whitelabel.domain}`, language, "e", eventSlug, CHECKOUT_ROUTE, "success"].join("/") + makeSearchParamString()
          }
        });

        if (stripeResponse.error) {
          // Throw stripe errors if there are any
          throw stripeResponse.error.message;
        } else {
          // Record that Stripe has confirmed the payment (in case we need to
          // retry the TB request)
          setStripePaymentConfirmed(true);
        }
      }
    } else {// Do something if no `stripe` or `elements` object
    } // Let Ticketbutler know Stripe has confirmed the payment.
    // If the request doesn't go through, we need to try again otherwise
    // the payment wont succeed in TB.


    const tbReq = await fetch(ticketbutlerApiUrl, {
      headers: makeTbRequestHeaders(language),
      method: "POST"
    });

    if (tbReq.ok) {
      checkoutNavigate("success/");
      return true;
    } else {
      throw Error();
    }
  }, [stripe, elements, stripePaymentConfirmed, clientSecret]);
  useScrollToError(Boolean(lastError));
  return /*#__PURE__*/React.createElement(_StyledForm5, {
    onSubmit: function (e) {
      e.preventDefault();
      makePayment();
    },
    _css57: styles.form
  }, /*#__PURE__*/React.createElement(_StyledP23, {
    _css58: styles.checkoutModalHeading
  }, t("event.payWithStripe")), /*#__PURE__*/React.createElement(_StyledDiv32, null, /*#__PURE__*/React.createElement(PaymentElement, null)), /*#__PURE__*/React.createElement(_StyledDiv33, null, /*#__PURE__*/React.createElement(LoadingButton, {
    loading: status === AsyncStates.Pending,
    success: status === AsyncStates.Success,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton10, {
    type: "submit",
    _css59: getThemedButton(theme)
  }, t("event.pay"))), lastError && /*#__PURE__*/React.createElement(_StyledP24, {
    className: "errorMessage"
  }, typeof lastError === "string" ? // It's a described error
  lastError : // It's another kind of error, show generic
  t("event.errorOccurred"))));
};

var _StyledDiv34 = _styled("div").withConfig({
  displayName: "app___StyledDiv34",
  componentId: "sc-1j24m7p-108"
})({
  display: "flex",
  justifyContent: "center "
});

export function StripePayment({
  theme,
  purchaseUUID,
  whitelabel
}) {
  const ticketbutlerApiUrl = React.useRef([API_HOST, "purchases", purchaseUUID, `stripe/${urlParams.get("extras_flow") ? "?checkout_flow=extras" : ""}`].join("/"));
  const language = useLanguage();
  const [stripeConfig, setStripeConfig] = React.useState(null);
  React.useEffect(function () {
    async function createStripePayment() {
      const req = await fetch(ticketbutlerApiUrl.current, {
        headers: makeTbRequestHeaders(language)
      });
      const res = await req.json();

      if (req.ok) {
        return res;
      } else {
        throw res;
      }
    }

    async function initStripe() {
      // Load Stripe API and create order in sync
      const stripeInfo = await createStripePayment();
      setStripeConfig(stripeInfo);
    }

    initStripe();
  }, [purchaseUUID, language]);

  if (stripeConfig) {
    return /*#__PURE__*/React.createElement(Elements, {
      stripe: loadStripe(stripeConfig.stripe_key, {
        stripeAccount: stripeConfig.stripe_account
      }),
      options: {
        locale: language,
        clientSecret: stripeConfig.client_secret
      }
    }, /*#__PURE__*/React.createElement(StripeForm, {
      theme: theme,
      ticketbutlerApiUrl: ticketbutlerApiUrl.current,
      clientSecret: stripeConfig.client_secret,
      whitelabel: whitelabel
    }));
  } else {
    return /*#__PURE__*/React.createElement(_StyledDiv34, null, /*#__PURE__*/React.createElement(Spinner, {
      color: theme.colour_primary
    }));
  }
}
export const paymentOption = {
  border: "2px solid #C5D0DE",
  borderRadius: 5,
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 25,
  margin: 5,
  padding: "15px 10px",
  cursor: "pointer",
  width: "100%",
  maxWidth: 320,
  overflow: "hidden"
};

var _StyledForm6 = _styled("form").withConfig({
  displayName: "app___StyledForm6",
  componentId: "sc-1j24m7p-109"
})(["", ""], p => p._css60);

var _StyledDiv35 = _styled("div").withConfig({
  displayName: "app___StyledDiv35",
  componentId: "sc-1j24m7p-110"
})({
  display: "flex",
  flexDirection: "column"
});

var _StyledP25 = _styled("p").withConfig({
  displayName: "app___StyledP25",
  componentId: "sc-1j24m7p-111"
})(["", ""], p => p._css61);

var _StyledLabel15 = _styled("label").withConfig({
  displayName: "app___StyledLabel15",
  componentId: "sc-1j24m7p-112"
})(["", ""], p => p._css62);

var _StyledInput9 = _styled("input").withConfig({
  displayName: "app___StyledInput9",
  componentId: "sc-1j24m7p-113"
})(["", ""], p => p._css63);

var _StyledLabel16 = _styled("label").withConfig({
  displayName: "app___StyledLabel16",
  componentId: "sc-1j24m7p-114"
})(["", ""], p => p._css64);

var _StyledInput10 = _styled("input").withConfig({
  displayName: "app___StyledInput10",
  componentId: "sc-1j24m7p-115"
})(["", ""], p => p._css65);

var _StyledLabel17 = _styled("label").withConfig({
  displayName: "app___StyledLabel17",
  componentId: "sc-1j24m7p-116"
})(["", ""], p => p._css66);

var _StyledInput11 = _styled("input").withConfig({
  displayName: "app___StyledInput11",
  componentId: "sc-1j24m7p-117"
})(["", ""], p => p._css67);

var _StyledDiv36 = _styled("div").withConfig({
  displayName: "app___StyledDiv36",
  componentId: "sc-1j24m7p-118"
})({
  display: "flex",
  justifyContent: "space-between"
});

var _StyledLabel18 = _styled("label").withConfig({
  displayName: "app___StyledLabel18",
  componentId: "sc-1j24m7p-119"
})(["", ""], p => p._css68);

var _StyledInput12 = _styled("input").withConfig({
  displayName: "app___StyledInput12",
  componentId: "sc-1j24m7p-120"
})(["", ""], p => p._css69);

var _StyledLabel19 = _styled("label").withConfig({
  displayName: "app___StyledLabel19",
  componentId: "sc-1j24m7p-121"
})(["", ""], p => p._css70);

var _StyledInput13 = _styled("input").withConfig({
  displayName: "app___StyledInput13",
  componentId: "sc-1j24m7p-122"
})(["", ""], p => p._css71);

var _StyledLabel20 = _styled("label").withConfig({
  displayName: "app___StyledLabel20",
  componentId: "sc-1j24m7p-123"
})(["", ""], p => p._css72);

var _StyledInput14 = _styled("input").withConfig({
  displayName: "app___StyledInput14",
  componentId: "sc-1j24m7p-124"
})(["", ""], p => p._css73);

var _StyledLabel21 = _styled("label").withConfig({
  displayName: "app___StyledLabel21",
  componentId: "sc-1j24m7p-125"
})(["", ""], p => p._css74);

var _StyledInput15 = _styled("input").withConfig({
  displayName: "app___StyledInput15",
  componentId: "sc-1j24m7p-126"
})(["", ""], p => p._css75);

var _StyledDiv37 = _styled("div").withConfig({
  displayName: "app___StyledDiv37",
  componentId: "sc-1j24m7p-127"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
});

var _StyledButton11 = _styled("button").withConfig({
  displayName: "app___StyledButton11",
  componentId: "sc-1j24m7p-128"
})(["", ""], p => p._css76);

var _StyledP26 = _styled("p").withConfig({
  displayName: "app___StyledP26",
  componentId: "sc-1j24m7p-129"
})({
  color: "red",
  textAlign: "center"
});

var _StyledDiv38 = _styled("div").withConfig({
  displayName: "app___StyledDiv38",
  componentId: "sc-1j24m7p-130"
})(["", ""], p => p._css77);

export function InvoiceForm({
  theme,
  purchase,
  updateReservation
}) {
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const language = useLanguage();
  const checkoutNavigate = useCheckoutNavigate();
  const {
    trigger: updatePurchase,
    status,
    reset,
    lastError
  } = useAsyncStatus(async function updatePurchase(values) {
    // Server validate & update the order
    const req = await fetch([API_HOST, "purchases", purchase.uuid, `invoice/${urlParams.get("extras_flow") ? "?checkout_flow=extras" : ""}`].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify(values)
    });

    if (req.ok) {
      checkoutNavigate("invoice-confirmation/");
    } else {
      const errors = await req.json();
      throw errors;
    }
  });
  React.useEffect(() => {
    updateReservation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useScrollToError(Boolean(lastError));
  return /*#__PURE__*/React.createElement(_StyledForm6, {
    onChange: reset,
    onSubmit: function (e) {
      e.preventDefault();
      const values = serialize(e.target, {
        hash: true
      });
      updatePurchase(values);
    },
    _css60: styles.form
  }, /*#__PURE__*/React.createElement(_StyledDiv35, null, /*#__PURE__*/React.createElement(_StyledP25, {
    _css61: styles.checkoutModalHeading
  }, t("event.invoiceInformation")), /*#__PURE__*/React.createElement(_StyledLabel15, {
    _css62: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.CVRNumber"), " *"), /*#__PURE__*/React.createElement(_StyledInput9, {
    name: "cvr",
    required: true,
    _css63: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "cvr")
  })), /*#__PURE__*/React.createElement(_StyledLabel16, {
    _css64: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.companyOrInstitutionName"), " *"), /*#__PURE__*/React.createElement(_StyledInput10, {
    name: "business_name",
    required: true,
    _css65: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "business_name")
  })), /*#__PURE__*/React.createElement(_StyledLabel17, {
    _css66: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.addressForInvoice"), " *"), /*#__PURE__*/React.createElement(_StyledInput11, {
    name: "street",
    required: true,
    defaultValue: purchase.address?.street,
    _css67: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "street")
  })), /*#__PURE__*/React.createElement(_StyledDiv36, null, /*#__PURE__*/React.createElement(_StyledLabel18, {
    _css68: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.postCode"), " *"), /*#__PURE__*/React.createElement(_StyledInput12, {
    name: "postcode",
    required: true,
    defaultValue: purchase?.address?.postcode,
    _css69: [styles.input, {
      maxWidth: 120
    }]
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "postcode")
  })), /*#__PURE__*/React.createElement(_StyledLabel19, {
    _css70: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.city"), " *"), /*#__PURE__*/React.createElement(_StyledInput13, {
    name: "city",
    required: true,
    defaultValue: purchase?.address?.city,
    _css71: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "city")
  }))), /*#__PURE__*/React.createElement(_StyledLabel20, {
    _css72: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.paymentReference")), /*#__PURE__*/React.createElement(_StyledInput14, {
    name: "ean_reference",
    _css73: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "ean_reference")
  })), /*#__PURE__*/React.createElement(_StyledLabel21, {
    _css74: styles.inputLabel
  }, /*#__PURE__*/React.createElement("span", null, t("event.EANNumber")), /*#__PURE__*/React.createElement(_StyledInput15, {
    name: "ean",
    minLength: 13,
    maxLength: 13,
    _css75: styles.input
  }), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(lastError, "ean")
  }))), /*#__PURE__*/React.createElement(_StyledDiv37, null, /*#__PURE__*/React.createElement(LoadingButton, {
    loading: status === AsyncStates.Pending,
    success: status === AsyncStates.Success,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton11, {
    type: "submit",
    _css76: [getThemedButton(theme), {
      marginTop: 15
    }]
  }, t("event.placeOrder"))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrors, {
    larger: true,
    errors: getFieldError(lastError, "non_field_errors")
  }), lastError instanceof Error && /*#__PURE__*/React.createElement(_StyledP26, null, t("event.errorTryAgain"), ".")), /*#__PURE__*/React.createElement(_StyledDiv38, {
    role: "button",
    onClick: function () {
      history.goBack();
      updateReservation();
    },
    _css77: [styles.textButton, {
      color: "#63696d",
      marginTop: 10,
      fontSize: 12
    }]
  }, t("event.back").toLowerCase())));
}

function loadScript(attrs) {
  return new Promise(function (resolve, reject) {
    const script = document.createElement("script");

    for (const attr in attrs) {
      script.setAttribute(attr, attrs[attr]);
    }

    script.addEventListener("load", function () {
      resolve(script);
    });
    script.addEventListener("error", function () {
      reject(script);
    });
    if (document.body) document.body.appendChild(script);
  });
}

export function sortBySortId(a, b) {
  return (a.sort_id || 0) - (b.sort_id || 0);
} //! Delete when phone number backend v2 will be ready

var _StyledInput16 = _styled("input").withConfig({
  displayName: "app___StyledInput16",
  componentId: "sc-1j24m7p-131"
})(["", ""], p => p._css78);

export function PhoneInput({
  question,
  defaultValue,
  defaultCountryCode
}) {
  const [countryCode, setCountryCode] = React.useState(defaultCountryCode || "+45");
  const [phoneNumber, setPhoneNumber] = React.useState(defaultValue ? `${defaultValue}` : "");
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      maxWidth: "100%",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    "data-testid": "phone-question-hidden",
    name: question.uuid,
    value: phoneNumber.length > 0 ? countryCode + phoneNumber : ""
  }), /*#__PURE__*/React.createElement(CountryDialingCodeSelect, {
    customName: null,
    defaultCode: countryCode,
    onChange: setCountryCode
  }), /*#__PURE__*/React.createElement(_StyledInput16, {
    "data-testid": "phone-question",
    type: "text",
    required: question.required,
    defaultValue: defaultValue,
    onChange: e => setPhoneNumber(e.target.value),
    _css78: [styles.input, {
      flexGrow: 1
    }]
  }));
}

var _StyledTextarea2 = _styled("textarea").withConfig({
  displayName: "app___StyledTextarea2",
  componentId: "sc-1j24m7p-132"
})(["", ""], p => p._css79);

var _StyledInput17 = _styled("input").withConfig({
  displayName: "app___StyledInput17",
  componentId: "sc-1j24m7p-133"
})(["", ""], p => p._css80);

var _StyledInput18 = _styled("input").withConfig({
  displayName: "app___StyledInput18",
  componentId: "sc-1j24m7p-134"
})(["", ""], p => p._css81);

var _StyledInput19 = _styled("input").withConfig({
  displayName: "app___StyledInput19",
  componentId: "sc-1j24m7p-135"
})(["", ""], p => p._css82);

var _StyledInput20 = _styled("input").withConfig({
  displayName: "app___StyledInput20",
  componentId: "sc-1j24m7p-136"
})(["", ""], p => p._css83);

var _StyledInput21 = _styled("input").withConfig({
  displayName: "app___StyledInput21",
  componentId: "sc-1j24m7p-137"
})(["", ""], p => p._css84);

var _StyledLabel22 = _styled("label").withConfig({
  displayName: "app___StyledLabel22",
  componentId: "sc-1j24m7p-138"
})(["", ""], p => p._css85);

var _StyledInput22 = _styled("input").withConfig({
  displayName: "app___StyledInput22",
  componentId: "sc-1j24m7p-139"
})(["", ""], p => p._css86);

var _StyledLabel23 = _styled("label").withConfig({
  displayName: "app___StyledLabel23",
  componentId: "sc-1j24m7p-140"
})(["", ""], p => p._css87);

var _StyledInput23 = _styled("input").withConfig({
  displayName: "app___StyledInput23",
  componentId: "sc-1j24m7p-141"
})(["", ""], p => p._css88);

var _StyledLabel24 = _styled("label").withConfig({
  displayName: "app___StyledLabel24",
  componentId: "sc-1j24m7p-142"
})(["", ""], p => p._css89);

var _StyledInput24 = _styled("input").withConfig({
  displayName: "app___StyledInput24",
  componentId: "sc-1j24m7p-143"
})(["", ""], p => p._css90);

var _StyledLabel25 = _styled("label").withConfig({
  displayName: "app___StyledLabel25",
  componentId: "sc-1j24m7p-144"
})(["", ""], p => p._css91);

var _StyledInput25 = _styled("input").withConfig({
  displayName: "app___StyledInput25",
  componentId: "sc-1j24m7p-145"
})(["", ""], p => p._css92);

var _StyledLabel26 = _styled("label").withConfig({
  displayName: "app___StyledLabel26",
  componentId: "sc-1j24m7p-146"
})(["", ""], p => p._css93);

var _StyledInput26 = _styled("input").withConfig({
  displayName: "app___StyledInput26",
  componentId: "sc-1j24m7p-147"
})(["", ""], p => p._css94);

var _StyledInput27 = _styled("input").withConfig({
  displayName: "app___StyledInput27",
  componentId: "sc-1j24m7p-148"
})(["", ""], p => p._css95);

export function getInputForCustomQuestion(question, defaultValues, countryCode) {
  let defaultValue;
  let choiceDefaultValues;
  let fullNameDefaultValues;

  if (Array.isArray(defaultValues)) {
    // An answer that has two values (primary and secondary)
    fullNameDefaultValues = defaultValues;
  } else if (typeof defaultValues === "object") {
    // A multiple choice answer, where there can be multiple answers
    choiceDefaultValues = defaultValues;
  } else {
    // An answer that has one value (the most common type)
    defaultValue = defaultValues;
  }

  switch (question.variation) {
    case "SELECT":
      {
        let options = []; // Allow the user to select "No answer" if the question is not required

        if (!question.required) {
          options = options.concat({
            value: "",
            label: t("event.noAnswerProvided")
          });
        }

        options = (question.choices || []).sort(sortBySortId).filter(({
          limit,
          used
        }) => limit ? limit > used : true).map(({
          uuid,
          label
        }) => {
          return {
            value: uuid,
            label: label
          };
        });
        return /*#__PURE__*/React.createElement("div", {
          "data-testid": "select-question"
        }, /*#__PURE__*/React.createElement(Select, {
          name: question.uuid,
          required: question.required,
          placeholder: t("event.noAnswerProvided"),
          isSearchable: false,
          styles: {
            container: defaultStyle => ({ ...defaultStyle,
              fontSize: "16px",
              width: "100%",
              height: "40px"
            }),
            control: defaultStyle => ({ ...defaultStyle,
              height: 40
            })
          },
          defaultValue: defaultValue ? options[options.findIndex(({
            value
          }) => value === defaultValue)] : undefined,
          options: options
        }));
      }

    case "SELECT_MULTIPLE":
    case "CHECKBOX":
      return (question.choices || []).sort(sortBySortId).filter(({
        limit,
        used
      }) => limit ? limit > used : true).map(({
        uuid,
        label
      }) => {
        return /*#__PURE__*/React.createElement("div", {
          key: uuid,
          "data-testid": "checkbox-question"
        }, /*#__PURE__*/React.createElement(Checkbox, {
          label: label,
          initialChecked: Boolean(choiceDefaultValues && choiceDefaultValues[uuid]) // Send <UUID>: true for each selected choice
          ,
          id: uuid,
          name: uuid
        }));
      });

    case "TEXTAREA":
      return /*#__PURE__*/React.createElement(_StyledTextarea2, {
        "data-testid": "textarea-question",
        rows: 5,
        name: question.uuid,
        required: question.required,
        defaultValue: defaultValue,
        _css79: styles.input
      });

    case "NAME":
      return /*#__PURE__*/React.createElement(_StyledInput17, {
        "data-testid": "name-question",
        type: "text",
        name: question.uuid,
        required: question.required,
        defaultValue: defaultValue,
        placeholder: t("event.firstName"),
        _css80: styles.input
      });

    case "NAME_FIRST_LAST":
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "full-name-question",
        style: {
          display: "flex",
          flexDirection: "column"
        }
      }, /*#__PURE__*/React.createElement(_StyledInput18, {
        type: "text" // The full name question uses the secondary field to accomodate both first and last name values.
        // So here we map the name to suit the API
        ,
        name: question.uuid + "[answer_value]",
        required: question.required,
        defaultValue: fullNameDefaultValues && fullNameDefaultValues[0],
        placeholder: t("event.firstName"),
        _css81: styles.input
      }), /*#__PURE__*/React.createElement(_StyledInput19, {
        type: "text" // The full name question uses the secondary field to accomodate both first and last name values.
        // So here we map the name to suit the API
        ,
        name: question.uuid + "[answer_value_secondary]",
        required: question.required,
        defaultValue: fullNameDefaultValues && fullNameDefaultValues[1],
        placeholder: t("event.lastName"),
        _css82: [styles.input, {
          marginTop: "10px"
        }]
      }));

    case "NUMBER":
      return /*#__PURE__*/React.createElement(_StyledInput20, {
        "data-testid": "number-question",
        type: "number",
        name: question.uuid,
        required: question.required,
        defaultValue: defaultValue,
        _css83: styles.input
      });

    case "EMAIL":
      return /*#__PURE__*/React.createElement(_StyledInput21, {
        "data-testid": "email-question",
        type: "email",
        name: question.uuid,
        required: question.required,
        defaultValue: defaultValue,
        _css84: styles.input
      });

    case "PHONE":
      return (
        /*#__PURE__*/
        //!Will be returned with phone number API v2
        // <div
        //   style={{
        //     display: "flex",
        //     maxWidth: "100%",
        //     width: "100%",
        //   }}
        // >
        //   <CountryDialingCodeSelect
        //     defaultCode={countryCode}
        //     customName={question.uuid}
        //   />
        //   <input
        //     css={[styles.input, { flexGrow: 1 }]}
        //     data-testid="phone-question"
        //     type="text"
        //     name={question.uuid}
        //     required={question.required}
        //     defaultValue={defaultValue}
        //   />
        // </div>
        React.createElement(PhoneInput, {
          question: question,
          defaultValue: defaultValue,
          defaultCountryCode: countryCode
        })
      );

    case "ADDRESS":
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "address-question",
        style: {
          display: "flex",
          flexDirection: "column",
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(_StyledLabel22, {
        _css85: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, t("event.streetLine") + " " + "1" + " " + (question.required ? " *" : "")), /*#__PURE__*/React.createElement(_StyledInput22, {
        type: "text",
        name: question.uuid + "[address_street]",
        required: question.required,
        _css86: styles.input
      })), /*#__PURE__*/React.createElement(_StyledLabel23, {
        _css87: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, t("event.streetLine") + " " + "2"), /*#__PURE__*/React.createElement(_StyledInput23, {
        type: "text",
        name: question.uuid + "[address_street_2]",
        _css88: styles.input
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(_StyledLabel24, {
        _css89: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, t("event.zipPostalCode") + " " + (question.required ? "*" : "")), /*#__PURE__*/React.createElement(_StyledInput24, {
        type: "text",
        name: question.uuid + "[address_postcode]",
        required: question.required,
        _css90: [styles.input, {
          maxWidth: "200px",
          marginRight: "20px"
        }]
      })), /*#__PURE__*/React.createElement(_StyledLabel25, {
        _css91: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, t("event.cityState") + " " + (question.required ? "*" : "")), /*#__PURE__*/React.createElement(_StyledInput25, {
        type: "text",
        name: question.uuid + "[address_city]",
        required: question.required,
        _css92: styles.input
      }))), /*#__PURE__*/React.createElement(_StyledLabel26, {
        _css93: styles.inputLabel
      }, /*#__PURE__*/React.createElement("span", null, t("event.country") + " " + (question.required ? "*" : "")), /*#__PURE__*/React.createElement(_StyledInput26, {
        type: "text",
        name: question.uuid + "[address_country]",
        required: question.required,
        _css94: styles.input
      })));

    default:
      return /*#__PURE__*/React.createElement(_StyledInput27, {
        "data-testid": "input-question",
        type: "text",
        name: question.uuid,
        required: question.required,
        defaultValue: defaultValue,
        _css95: styles.input
      });
  }
}

var _StyledFooter = _styled("footer").withConfig({
  displayName: "app___StyledFooter",
  componentId: "sc-1j24m7p-149"
})(["", ""], p => p._css96);

var _StyledDiv39 = _styled("div").withConfig({
  displayName: "app___StyledDiv39",
  componentId: "sc-1j24m7p-150"
})({
  display: "flex",
  flexDirection: "column",
  padding: 25
});

var _StyledA3 = _styled("a").withConfig({
  displayName: "app___StyledA3",
  componentId: "sc-1j24m7p-151"
})({
  textDecoration: "none"
});

var _StyledDiv40 = _styled("div").withConfig({
  displayName: "app___StyledDiv40",
  componentId: "sc-1j24m7p-152"
})(p => ({
  border: p._css97,
  borderRadius: 4,
  backgroundColor: p._css98,
  color: "white",
  fontWeight: 600,
  marginBottom: 15,
  padding: "8px 10px",
  width: "max-content"
}));

var _StyledDiv41 = _styled("div").withConfig({
  displayName: "app___StyledDiv41",
  componentId: "sc-1j24m7p-153"
})({
  padding: "25px 0"
});

var _StyledSpan6 = _styled("span").withConfig({
  displayName: "app___StyledSpan6",
  componentId: "sc-1j24m7p-154"
})(["", ""], p => p._css99);

var _StyledSpan7 = _styled("span").withConfig({
  displayName: "app___StyledSpan7",
  componentId: "sc-1j24m7p-155"
})(["", ""], p => p._css100);

var _StyledSpan8 = _styled("span").withConfig({
  displayName: "app___StyledSpan8",
  componentId: "sc-1j24m7p-156"
})(["", ""], p => p._css101);

var _StyledSpan9 = _styled("span").withConfig({
  displayName: "app___StyledSpan9",
  componentId: "sc-1j24m7p-157"
})(["", ""], p => p._css102);

var _StyledSpan10 = _styled("span").withConfig({
  displayName: "app___StyledSpan10",
  componentId: "sc-1j24m7p-158"
})(["", ""], p => p._css103);

var _StyledDiv42 = _styled("div").withConfig({
  displayName: "app___StyledDiv42",
  componentId: "sc-1j24m7p-159"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  padding: 25
});

var _StyledA4 = _styled("a").withConfig({
  displayName: "app___StyledA4",
  componentId: "sc-1j24m7p-160"
})({
  padding: 2.5
});

var _StyledA5 = _styled("a").withConfig({
  displayName: "app___StyledA5",
  componentId: "sc-1j24m7p-161"
})({
  padding: 2.5,
  textAlign: "end"
});

var _StyledDiv43 = _styled("div").withConfig({
  displayName: "app___StyledDiv43",
  componentId: "sc-1j24m7p-162"
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "25px 0"
});

var _StyledDiv44 = _styled("div").withConfig({
  displayName: "app___StyledDiv44",
  componentId: "sc-1j24m7p-163"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end"
});

var _StyledA6 = _styled("a").withConfig({
  displayName: "app___StyledA6",
  componentId: "sc-1j24m7p-164"
})({
  padding: 2.5
});

var _StyledA7 = _styled("a").withConfig({
  displayName: "app___StyledA7",
  componentId: "sc-1j24m7p-165"
})({
  display: "block"
});

var _StyledDiv45 = _styled("div").withConfig({
  displayName: "app___StyledDiv45",
  componentId: "sc-1j24m7p-166"
})({
  marginTop: 20,
  padding: 2.5,
  textAlign: "right"
});

var _StyledSpan11 = _styled("span").withConfig({
  displayName: "app___StyledSpan11",
  componentId: "sc-1j24m7p-167"
})({
  display: "block",
  margin: "2.5px 0"
});

function Footer({
  whitelabel
}) {
  const {
    t
  } = useTranslation();
  const language = useLanguage();
  return /*#__PURE__*/React.createElement(_StyledFooter, {
    _css96: [{
      display: "flex",
      justifyContent: "space-between",
      fontSize: 13,
      padding: 20
    }, whitelabel.slug === "flyingsuperkids" && {
      color: "white",
      a: {
        color: "white"
      }
    }]
  }, /*#__PURE__*/React.createElement(_StyledDiv39, null, /*#__PURE__*/React.createElement(_StyledA3, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: `https://${whitelabel.domain}/${language}/purchase/user-resend-tickets/`
  }, /*#__PURE__*/React.createElement(_StyledDiv40, {
    _css97: `1px solid ${whitelabel.colour_primary}`,
    _css98: whitelabel.colour_primary
  }, t("event.resendMyTicket"))), whitelabel && /*#__PURE__*/React.createElement(_StyledDiv41, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledSpan6, {
    _css99: styles.footerInfoItem
  }, whitelabel.contact_details.business_name), /*#__PURE__*/React.createElement(_StyledSpan7, {
    _css100: styles.footerInfoItem
  }, whitelabel.contact_details.street, " ", whitelabel.contact_details.street_2), /*#__PURE__*/React.createElement(_StyledSpan8, {
    _css101: styles.footerInfoItem
  }, whitelabel.contact_details.postcode, " ", whitelabel.contact_details.city), /*#__PURE__*/React.createElement(_StyledSpan9, {
    _css102: styles.footerInfoItem
  }, whitelabel.contact_details.country), /*#__PURE__*/React.createElement(_StyledSpan10, {
    _css103: styles.footerInfoItem
  }, t("event.CVRNumber"), ": ", whitelabel.contact_details.cvr)))), /*#__PURE__*/React.createElement(_StyledDiv42, null, /*#__PURE__*/React.createElement(_StyledA4, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: `https://support.ticketbutler.io/portal/${language}/kb/ticketbutler`
  }, t("event.helpCenter")), [{
    title: t("event.termsAndConditions"),
    slug: "tandc"
  }, {
    title: t("event.privacyPolicy"),
    slug: "privacy-policy"
  }].map(({
    title,
    slug
  }) => /*#__PURE__*/React.createElement(_StyledA5, {
    key: slug,
    href: "/" + language + "/" + slug,
    target: "_blank",
    rel: "noreferrer noopener"
  }, title)), /*#__PURE__*/React.createElement(_StyledDiv43, null, /*#__PURE__*/React.createElement(_StyledDiv44, null, whitelabel?.footer_nav_items?.map(item => /*#__PURE__*/React.createElement(_StyledA6, {
    key: item.slug,
    target: "_blank",
    rel: "noopener noreferrer",
    href: item.override_url || "/" + language + "/" + item.slug
  }, item.title)), whitelabel && whitelabel.facebook_url && /*#__PURE__*/React.createElement(_StyledA7, {
    href: whitelabel.facebook_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, t("event.findOnFacebook")))), /*#__PURE__*/React.createElement(_StyledDiv45, null, /*#__PURE__*/React.createElement(_StyledSpan11, null, t("event.ticketingPoweredBy"), ":"), /*#__PURE__*/React.createElement("a", {
    href: "https://ticketbutler.io",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Ticketbutler"), " ", "(", t("event.CVRNumber"), ": 38404687)")));
}

var _StyledDiv46 = _styled("div").withConfig({
  displayName: "app___StyledDiv46",
  componentId: "sc-1j24m7p-168"
})(["", ""], p => p._css104);

function Hamburger({
  isActive,
  size = 30,
  color = "#63696d"
}) {
  return /*#__PURE__*/React.createElement(_StyledDiv46, {
    _css104: [{
      display: "flex",
      flexDirection: "column",
      width: size,
      "> div": {
        backgroundColor: color,
        height: size / 10,
        margin: size / 10 + "px 0",
        transition: "200ms all",
        maxWidth: size,
        borderRadius: 2
      }
    }, isActive && {
      "> div": {
        "&:first-child": {
          transform: `translateY(${size * 0.3}px) rotate(-135deg)`
        },
        "&:nth-child(2)": {
          maxWidth: 0,
          marginLeft: 10
        },
        "&:last-child": {
          transform: `translateY(-${size * 0.3}px) rotate(135deg)`
        }
      }
    }]
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null));
}

function showIcon(status) {
  if (status === true) {
    return /*#__PURE__*/React.createElement(VerifiedIcon, null);
  } else if (status === false) {
    return /*#__PURE__*/React.createElement(CancelIcon, null);
  } else {
    return null;
  }
}

function VerifiedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      margin: "auto -30px"
    },
    "data-testid": "verified-icon",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#7ED321",
    cx: "9",
    cy: "9",
    r: "9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "3,10.43 7.065,14.5 15,6.554 12.943,4.5 7.055,10.382 5.057,8.376"
  }));
}

function CancelIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      margin: "auto -30px"
    },
    width: "18px",
    height: "18px",
    viewBox: "0 0 19.18 19.18"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E70000",
    cx: "9.59",
    cy: "9.59",
    r: "9.59"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#f6f6f6",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    x1: "4.34",
    y1: "4.39",
    x2: "14.73",
    y2: "14.78"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#f6f6f6",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    x1: "14.91",
    y1: "4.32",
    x2: "4.37",
    y2: "14.86"
  }));
}

export function getFieldError(error, key) {
  if (error && !(error instanceof Error)) {
    if (Array.isArray(error[key])) {
      // @ts-ignore: Happy enough with Array.isArray for checking non-nested
      // errors lists
      return error[key];
    }
  }

  return null;
}

var _StyledDiv47 = _styled("div").withConfig({
  displayName: "app___StyledDiv47",
  componentId: "sc-1j24m7p-169"
})({
  display: "flex",
  justifyContent: "center",
  padding: "80px 10px"
});

var _StyledDiv48 = _styled("div").withConfig({
  displayName: "app___StyledDiv48",
  componentId: "sc-1j24m7p-170"
})({
  maxWidth: 720
});

class ErrorBoundaryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidMount() {
    this.props.i18n?.changeLanguage(this.props.language);
  }

  componentDidCatch(error, stackTrace) {
    console.error(error, stackTrace);
    Sentry.captureException(error);
    this.setState({
      hasError: true
    });
  }

  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement(_StyledDiv47, null, /*#__PURE__*/React.createElement(_StyledDiv48, null, /*#__PURE__*/React.createElement("h1", null, this.props.t("event.sentMessageToFix"), "."), /*#__PURE__*/React.createElement("p", null, this.props.t("event.contactOurSupport"), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "hello@ticketbutler.io"))));
    }

    return this.props.children || null;
  }

}

export const ErrorBoundary = withTranslation()(ErrorBoundaryComponent);
export function makeSearchParamString(...searchParams) {
  const params = new URLSearchParams(window.location.search);

  for (const [key, value] of searchParams) {
    if (value) {
      params.set(key, value);
    } else {
      // No value means delete it
      params.delete(key);
    }
  }

  const string = params.toString();
  return string.length > 0 ? "?" + string : "";
}
export function LanguageDetector(props) {
  const language = useLanguage();
  const {
    i18n
  } = useTranslation();
  React.useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);
  return props.children;
}
export function AppLanguageContainer() {
  const {
    i18n
  } = useTranslation();
  const location = useLocation();
  return /*#__PURE__*/React.createElement(Switch, null, Object.values(Language).map(language => {
    return /*#__PURE__*/React.createElement(Route, {
      key: language,
      path: `/${language}`
    }, /*#__PURE__*/React.createElement(ErrorBoundary, {
      language: language
    }, /*#__PURE__*/React.createElement(LanguageDetector, null, /*#__PURE__*/React.createElement(App, null))));
  }), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(Redirect, {
    to: "/" + i18n.resolvedLanguage.slice(0, 2) + location.pathname + location.search
  })));
} // Router rendering here to pass custom history object to the tests

export default function Root() {
  return /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(AppLanguageContainer, null));
}